import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, Validators, FormArray, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NewProjectHeaderComponent } from './new-project-header/new-project-header.component';
import { NewProjectHeroComponent } from './new-project-hero/new-project-hero.component';
import { NewProjectViviendasNavComponent } from './new-project-viviendas-nav/new-project-viviendas-nav.component';
import { NewProjectPropertyFeaturesComponent } from './new-project-property-features/new-project-property-features.component';
import { NewProjectTabsComponent } from './new-project-tabs/new-project-tabs.component';
import { NewProjectGeneralInfoComponent } from './new-project-general-info/new-project-general-info.component';
import { NewProjectGalleryComponent } from './new-project-gallery/new-project-gallery.component';
import { NewProjectFinancialComponent } from './new-project-financial/new-project-financial.component';
import { NewProjectCalendarComponent } from './new-project-calendar/new-project-calendar.component';
import { NewProjectDocumentsComponent } from './new-project-documents/new-project-documents.component';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { finalize } from 'rxjs/operators';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import Swal from 'sweetalert2';
import { ProjectWizardComponent } from './project-wizard/project-wizard.component';
import * as jsonManager from '../../abis/Manager.json';
import { environment } from '../../../environments/environment';
import { ConnectionsService } from '../../services/connectionsWeb3/connections.service';
import { percentage } from '@angular/fire/storage';
import { LoaderService } from '../../services/loader.service';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { StatusUpdateService } from '../../services/checkStatus/status-update.service';

import { AuthService } from '../../services/auth.service';
import { ProjectTimelineService } from '../../services/project-timeline.service';
import { ProjectCreateDetail, ViviendaDetail, PropertyDetail, ProjectStatus, KeyDates, FinancialAnalysis, InvestmentBreakdown, AdditionalDocuments, CalendarEvent } from '../../interfaces/project-detail.interface';
import { ProjectDataAdapterService } from '../../services/adapters/project-data-adapter.service';
import { ProjectsV1Service } from '../../services/projects/projects-v1.service';
import { FinancialSectionService } from './new-project-financial/services/financial-section.service';

@Component({
  selector: 'app-new-proyect',
  templateUrl: './new-proyect.component.html',
  styleUrls: ['./new-proyect.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    NewProjectHeaderComponent,
    NewProjectHeroComponent,
    NewProjectViviendasNavComponent,
    NewProjectPropertyFeaturesComponent,
    NewProjectTabsComponent,
    NewProjectGeneralInfoComponent,
    NewProjectGalleryComponent,
    NewProjectFinancialComponent,
    NewProjectCalendarComponent,
    NewProjectDocumentsComponent,
    ProjectWizardComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class NewProyectComponent implements OnInit, OnChanges {
  @Input() projectToEdit: any = null; // Proyecto a editar (null para crear nuevo)
  @Output() close = new EventEmitter<boolean>(); // Evento para cerrar el modal/componente

  id: string = Date.now().toString();
  formNewNft: FormGroup = this.createFormNewNft();
  activeTab: string = 'informacion-general';
  activeViviendaIndex: number = 0; // Índice de la vivienda activa
  mainPropertyIndex: number = 0; // Index of the property that represents the project
  mainPropertyCoverIndex: number = 0; // Index of the gallery image in the main property to use as cover
  loadingFlag: boolean = false;
  isEditMode: boolean = false; // Indica si estamos editando o creando

  ourAddress: string | undefined;
  web3: any | undefined;
  abiManager: any = jsonManager;
  contractManager: any | undefined;
  
  // Propiedades para el header
  addressUser: string | null = null;
  addressUserTruncate: string | null = null;
  hideBlockchain: boolean = true;

  // Propiedades para manejar proyectos en blockchain
  projectInBlockchain: boolean = false;
  readonlyFields: string[] = [];

  // Propiedades para manejar imágenes y documentos
  fotoMain: string | null = null;
  whitePaper: string | null = null;
  dosier: string | null = null;
  infoToken: string | null = null;
  
  // Archivos locales para subir cuando se confirme el proyecto
  localMainImageFile: File | null = null;
  localDocuments: {[key: string]: File} = {};
  localGalleryImages: {[propertyId: string]: {[index: number]: File}} = {}; // Imágenes de galería por propiedad

  private readonly DRAFT_STORAGE_KEY = 'domoblock-new-project-draft';
  draftAvailable: boolean = false;

  readonly ordenAtributos = ["Habitaciones", "Banios", "Cocina", "Comedor", "Garaje"];
  
  // Campos disponibles para selección dinámica
  readonly camposDisponibles = [
    { id: 'planta', nombre: 'Planta', tipo: 'numerico', icono: '🏢' },
    { id: 'habitaciones', nombre: 'Habitaciones', tipo: 'numerico', icono: '🛏️' },
    { id: 'banos', nombre: 'Baños', tipo: 'numerico', icono: '🚿' },
    { id: 'exterior', nombre: 'Exterior', tipo: 'si_no', icono: '☀️' },
    { id: 'ascensor', nombre: 'Ascensor', tipo: 'si_no', icono: '🛗' },
    { id: 'metros_cuadrados', nombre: 'M²', tipo: 'numerico', icono: '📐' },
    { id: 'atico', nombre: 'Ático', tipo: 'si_no', icono: '🏠' },
    { id: 'duplex', nombre: 'Dúplex', tipo: 'si_no', icono: '🏘️' },
    { id: 'edificio', nombre: 'Edificio', tipo: 'si_no', icono: '🏢' },
    { id: 'piscina', nombre: 'Piscina', tipo: 'si_no', icono: '🏊' },
    { id: 'fachada_senorial', nombre: 'Fachada señorial', tipo: 'si_no', icono: '🏛️' }
  ];

  // Campos seleccionados actualmente (máximo 6)
  camposSeleccionados: string[] = ['planta', 'habitaciones', 'banos', 'exterior', 'ascensor', 'metros_cuadrados'];
  
  // Variables para manejar viviendas múltiples (eliminadas - ahora se manejan en el FormGroup principal)

  constructor(
    private storage: AngularFireStorage, 
    private afs: AngularFirestore, 
    private connSrv: ConnectionsService,
    private fns: AngularFireFunctions,
    private loaderService: LoaderService,
    private StatusUpdateService: StatusUpdateService,
    private authService: AuthService,
    private timelineService: ProjectTimelineService,
    private projectAdapter: ProjectDataAdapterService,
    private financialSectionService: FinancialSectionService,
    private projectsV1Service: ProjectsV1Service
  ) {
    this.web3 = this.connSrv.web3Instance;

    this.connSrv.addressUser
      .pipe()
      .subscribe((res: string) => {
      this.ourAddress = res;
      this.addressUser = res !== '' ? res : null;
      
      if (this.addressUser !== null) {
        this.addressUserTruncate = this.truncateEthAddress(this.addressUser);
      } else {
        this.addressUserTruncate = null;
      }
    });

    this.contractManager = new this.web3.eth.Contract(this.abiManager.abi, environment.config.ADDRESS_MANAGER);
    
    // Inicializar estado de blockchain
    this.initializeBlockchainState();
    
    console.log('­ƒöº [DEBUG] NewProyectComponent constructor completado');
  }

  ngOnInit(): void {
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      document.querySelector('.admin-container')?.scrollTo({ top: 0, behavior: 'smooth' });
    }, 50);
    this.checkAndLoadProject();
    this.setupBidirectionalSync();
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Si cambia el projectToEdit (por ejemplo, cuando se selecciona desde admin)
    if (changes['projectToEdit'] && !changes['projectToEdit'].firstChange) {
      console.log('🔄 projectToEdit cambió, recargando datos...');
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        document.querySelector('.admin-container')?.scrollTo({ top: 0, behavior: 'smooth' });
      }, 50);
      this.checkAndLoadProject();
    }
  }

  private setupBidirectionalSync(): void {
    // Auto-completar la "Fecha de lanzamiento" (por propiedad) con la "Fecha de activación"
    // del proyecto. Solo se rellena si la propiedad activa aún no tiene fecha, de modo que
    // siga siendo editable de forma independiente. Ambos usan el formato "yyyy-MM-ddTHH:mm".
    this.formNewNft.get('activationDate')?.valueChanges.subscribe(value => {
      if (!value) {
        return;
      }
      const launchControl = this.activeProperty?.get('launchDate');
      if (launchControl && !launchControl.value) {
        launchControl.setValue(value, { emitEvent: false });
      }
    });

    // Sincronizar de Hero (formNewNft a nivel global) hacia Información General (activeProperty)
    this.formNewNft.get('annualProfitability')?.valueChanges.subscribe(value => {
      const activeProp = this.activeProperty;
      if (activeProp) {
        const irrControl = activeProp.get('actualIRR');
        if (irrControl && irrControl.value !== value) {
          irrControl.setValue(value, { emitEvent: false });
        }
      }
    });

    this.formNewNft.get('estimatedDeliveryPeriod')?.valueChanges.subscribe(value => {
      const activeProp = this.activeProperty;
      if (activeProp) {
        const durControl = activeProp.get('actualDuration');
        if (durControl && durControl.value !== value) {
          durControl.setValue(value, { emitEvent: false });
        }
      }
    });

    // Sincronizar de Información General hacia Hero
    // Nos suscribimos a cambios en todo el array de properties
    this.formNewNft.get('properties')?.valueChanges.subscribe(() => {
      const activeProp = this.activeProperty;
      if (activeProp) {
         const irrValue = activeProp.get('actualIRR')?.value;
         const rootIrrControl = this.formNewNft.get('annualProfitability');
         if (irrValue !== undefined && irrValue !== null && rootIrrControl && rootIrrControl.value !== irrValue) {
            rootIrrControl.setValue(irrValue, { emitEvent: false });
         }

         const durValue = activeProp.get('actualDuration')?.value;
         const rootDurControl = this.formNewNft.get('estimatedDeliveryPeriod');
         if (durValue !== undefined && durValue !== null && rootDurControl && rootDurControl.value !== durValue) {
            rootDurControl.setValue(durValue, { emitEvent: false });
         }
      }
    });
  }

  private checkAndLoadProject(): void {
    this.isEditMode = this.projectToEdit !== null && this.projectToEdit !== undefined;
    
    if (this.isEditMode) {
      console.log('📝 ========== MODO EDICIÓN ACTIVADO ==========');
      console.log('📝 Proyecto completo recibido:', JSON.stringify(this.projectToEdit, null, 2));
      console.log('📝 ID del proyecto:', this.projectToEdit.id);
      console.log('📝 ¿Tiene properties?', !!this.projectToEdit.properties);
      console.log('📝 Properties es array?', Array.isArray(this.projectToEdit.properties));
      console.log('📝 Cantidad de properties:', this.projectToEdit.properties?.length);
      console.log('📝 Properties completo:', this.projectToEdit.properties);
      console.log('📝 Tipo de properties:', typeof this.projectToEdit.properties);
      if (this.projectToEdit.properties && Array.isArray(this.projectToEdit.properties)) {
        console.log('📝 Detalle de cada property:');
        this.projectToEdit.properties.forEach((prop: any, idx: number) => {
          console.log(`  Property ${idx}:`, prop);
        });
      }
      console.log('📝 ============================================');
      this.id = this.projectToEdit.id || Date.now().toString();
      this.loadProjectData();
      this.showPrefillModal();
    } else {
      // Limpiar datos previos del servicio para evitar que aparezcan datos de "Ver Detalles"
      this.financialSectionService.resetToDefaultSections();

      // Intentar cargar borrador antes de mostrar el prefill
      const draftLoaded = this.loadDraftIfAvailable();
      if (!draftLoaded) {
        // Mostrar modal de prefill solo para proyectos nuevos sin borrador
        this.showPrefillModal();
      }
    }
  }

  showWizardModal: boolean = false;
  wizardInitialData: any = null;

  async showPrefillModal() {
    this.wizardInitialData = this.getWizardData();
    this.showWizardModal = true;
  }

  handleWizardComplete(data: any) {
    this.showWizardModal = false;
    this.applyPrefillData(data);
  }

  handleWizardCancel() {
    this.showWizardModal = false;
    const hasData = this.title?.value !== null && this.title?.value !== '';
    if (!this.isEditMode && !hasData) {
      this.close.emit(true);
    }
  }

  getWizardData() {
    return {
      ...(this.projectToEdit || {}),
      ...this.formNewNft.getRawValue(),
      blockchain: this.isProjectInBlockchain()
    };
  }

  private getMainPropertyForm(createIfMissing = true): FormGroup | null {
    if (!this.propertiesArray) return null;

    if (this.propertiesArray.length === 0) {
      if (!createIfMissing) return null;
      this.propertiesArray.push(this.createPropertyFormGroup());
      this.mainPropertyIndex = 0;
    }

    const safeIndex = Math.min(
      Math.max(0, this.mainPropertyIndex || 0),
      this.propertiesArray.length - 1
    );
    this.mainPropertyIndex = safeIndex;

    return this.propertiesArray.at(safeIndex) as FormGroup;
  }

  private getSafeMainPropertyIndex(collectionLength: number): number {
    if (collectionLength <= 0) return 0;
    return Math.min(Math.max(0, this.mainPropertyIndex || 0), collectionLength - 1);
  }

  private applyPrefillData(data: any) {
    try {
      console.log('Aplicando prefill data:', data);
      if (data.title) this.title?.patchValue(data.title);
      if (data.amountToSell != null) this.amountToSell?.patchValue(data.amountToSell);
      if (data.tokenSymbol) this.tokenSymbol?.patchValue(data.tokenSymbol);
      if (data.tokenName) this.tokenName?.patchValue(data.tokenName);
      if (data.propertyType) this.propertyType?.patchValue(data.propertyType);
      if (data.stableCoinAddress) this.stableCoinAddress?.patchValue(data.stableCoinAddress);
      if (data.aggregatorStableCoinDollar) this.aggregatorStableCoinDollar?.patchValue(data.aggregatorStableCoinDollar);
      if (data.tokenPrice != null) this.tokenPrice?.patchValue(data.tokenPrice);
      if (data.minimumInvestment != null) this.minimumInvestment?.patchValue(data.minimumInvestment);
      if (data.beneficiaryAddress) this.beneficiaryAddress?.patchValue(data.beneficiaryAddress);
      
      if (data.activationDate) {
        // Ensure format is correct for the internal model if needed, but the form usually handles datetime-local string
        this.activationDate?.patchValue(data.activationDate); 
      }
      
      // Inyectar documentos locales en la propiedad principal que se usa para persistir URLs legacy.
      const mainProp = this.getMainPropertyForm(true);
      const docsControl = mainProp?.get('documents');
      const currentDocs = docsControl && Array.isArray(docsControl.value) ? [...docsControl.value] : [];

      const processWizardFile = (fileData: any, docType: string, visualNameFallback: string, sectionType: string) => {
        if (fileData instanceof File) {
          this.localDocuments[docType] = fileData;
          const existingDoc = currentDocs.find((d: any) => d.docType === docType || d.name === fileData.name);
          if (existingDoc) {
            existingDoc.name = fileData.name || visualNameFallback;
            existingDoc.size = fileData.size;
            existingDoc.file = fileData;
            existingDoc.docType = docType;
            existingDoc.slot = docType;
            existingDoc.sectionType = sectionType;
            delete existingDoc.url;
          } else {
            currentDocs.push({
              id: `doc_${docType}_${Date.now()}`,
              name: fileData.name || visualNameFallback,
              docType,
              slot: docType,
              type: 'pdf',
              size: fileData.size,
              uploadDate: new Date().toISOString(),
              file: fileData,
              sectionType: sectionType
            });
          }
        }
      };

      processWizardFile(data.whitepaperFile, 'urlWhitepapperPdf', 'Whitepaper.pdf', 'proyecto');
      processWizardFile(data.dossierFile, 'urlDosierPdf', 'Dossier.pdf', 'proyecto');
      processWizardFile(data.loanSubscriptionAgreementFile, 'loanSubscriptionAgreement', 'Acuerdo_Prestamo.pdf', 'proyecto');
      processWizardFile(data.propertyRegistryFile, 'propertyRegistry', 'Nota_Simple.pdf', 'inmueble');
      processWizardFile(data.agentMandateContractFile, 'agentMandateContract', 'Contrato_Mandato.pdf', 'proyecto');
      
      if (docsControl) {
        docsControl.setValue(currentDocs);
      }
      
      if (data.proyectStatus) this.formNewNft.get('proyectStatus')?.patchValue(data.proyectStatus);
      if (data.mainImageUrl) {
        this.fotoMain = data.mainImageUrl;
        this.mainImageUrl?.patchValue(data.mainImageUrl);
      }
      console.log('Prefill data aplicado correctamente');
    } catch (e) {
      console.error('Error applying prefill data', e);
    }
  }

  // Prefill is handled by the handleWizardComplete method now

  private getLocalStorage(): Storage | null {
    if (typeof window === 'undefined' || !window.localStorage) {
      return null;
    }
    return window.localStorage;
  }

  private getDraftFromStorage(): any | null {
    const storage = this.getLocalStorage();
    if (!storage) {
      return null;
    }

    const rawDraft = storage.getItem(this.DRAFT_STORAGE_KEY);
    if (!rawDraft) {
      return null;
    }

    try {
      return JSON.parse(rawDraft);
    } catch (error) {
      console.error('Error parsing draft data:', error);
      storage.removeItem(this.DRAFT_STORAGE_KEY);
      return null;
    }
  }

  private persistDraftData(data: any): void {
    const storage = this.getLocalStorage();
    if (!storage) {
      throw new Error('El almacenamiento local no está disponible en este navegador.');
    }
    storage.setItem(this.DRAFT_STORAGE_KEY, JSON.stringify(data));
  }

  private clearDraftStorage(): void {
    const storage = this.getLocalStorage();
    if (storage) {
      storage.removeItem(this.DRAFT_STORAGE_KEY);
    }
    this.draftAvailable = false;
  }

  private loadDraftIfAvailable(): boolean {
    const draftData = this.getDraftFromStorage();
    if (!draftData) {
      this.draftAvailable = false;
      return false;
    }

    if (draftData.id) {
      this.id = draftData.id;
    }

    this.draftAvailable = true;

    const appliedCorrectly = this.applyDraftDataToForm(draftData);
    if (!appliedCorrectly) {
      this.draftAvailable = false;
      return false;
    }

    Swal.fire({
      icon: 'info',
      title: 'Borrador cargado',
      text: 'Se restauró tu progreso guardado.',
      timer: 2200,
      showConfirmButton: false
    });

    return true;
  }

  private applyDraftDataToForm(draftData: any): boolean {
    const originalProject = this.projectToEdit;
    const originalIsEditMode = this.isEditMode;

    try {
      this.projectToEdit = draftData;
      this.isEditMode = false;
      this.loadProjectData();
      return true;
    } catch (error) {
      console.error('Error loading draft data:', error);
      Swal.fire({
        icon: 'error',
        title: 'No se pudo cargar el borrador',
        text: 'El borrador guardado está dañado. Se eliminó automáticamente.'
      });
      this.clearDraftStorage();
      return false;
    } finally {
      this.projectToEdit = originalProject;
      this.isEditMode = originalIsEditMode;
    }
  }


  createFormNewNft() {
    return new FormGroup({
      // Campos principales del proyecto (compartidos)
      title: new FormControl(null, [Validators.required]),
      developer: new FormControl(null),
      country: new FormControl(null),
      stateRegion: new FormControl(null),
      city: new FormControl(null),
      neighborhood: new FormControl(null),
      postalCode: new FormControl(null),
      street: new FormControl(null),
      streetNumber: new FormControl(null),
      googleMapsIframe: new FormControl(null),
      description: new FormControl(null),
      activationDate: new FormControl(null, [Validators.required]),
      estimatedDeliveryPeriod: new FormControl(null),
      annualProfitability: new FormControl(0),
      amountToSell: new FormControl(null, [Validators.required, Validators.min(1)]),
      tokenPrice: new FormControl(null, [Validators.required, Validators.min(0.01)]),
      minimumInvestment: new FormControl(null, [Validators.required, Validators.min(1)]),
      stableCoinAddress: new FormControl('0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063', [Validators.required]),
      beneficiaryAddress: new FormControl(null),
      aggregatorStableCoinDollar: new FormControl('0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D', [Validators.required]),
      tokenInfoPdfUrl: new FormControl(null),
      mainImageUrl: new FormControl(null),
      toBlockchain: new FormControl(false),
      onlyInvestors: new FormControl(false),
      percentageToPrivateSale: new FormControl(null, [Validators.required, Validators.min(0), Validators.max(100)]),
      managingInvestments: new FormControl(false),
      tokenName: new FormControl(null, [Validators.required]),
      tokenSymbol: new FormControl(null, [Validators.required]),
      propertyType: new FormControl('House Flipping', [Validators.required]),
      projectInfo: new FormControl(null), // Ya no es obligatorio

      // Campos específicos de la estructura antigua (para compatibilidad)
      company: new FormControl(null),
      location: new FormControl(null),
      cp: new FormControl(null),
      iframeGoogleMaps: new FormControl(null),
      images: new FormControl([]),
      infoProyecto: new FormControl(null),
      mainImage: new FormControl(null),
      urlDosierPdf: new FormControl(null),
      urlInfoTokenPdf: new FormControl(null),
      urlWhitepapperPdf: new FormControl(null),
      nameTokens: new FormControl(null),
      symbolTokens: new FormControl(null),
      priceToken: new FormControl(null),
      annualReturn: new FormControl(null),
      estimatedDeliveryTime: new FormControl(null),
      blockchain: new FormControl(false),
      onlyInversors: new FormControl(false),
      projectWallet: new FormControl(null),
      sellerAddress: new FormControl(null),
      tokensAddress: new FormControl(null),
      dividendsAddress: new FormControl(null),
      NftID: new FormControl(null),
      endOfSale: new FormControl(null),
      hoursToSell: new FormControl(null),
      numberInvestors: new FormControl(null),
      amountSold: new FormControl(null),
      reserves: new FormControl(null),
      lastStatusUpdate: new FormControl(null),
      proyectStatus: new FormControl('En estudio'),
      hide: new FormControl(false),

      properties: new FormArray([this.createPropertyFormGroup()])
    })
  }

  // Método para crear un FormGroup para una propiedad individual
  createPropertyFormGroup(): FormGroup {
    return new FormGroup({
      id: new FormControl(Date.now().toString() + Math.random().toString(36).substr(2, 9)),
      name: new FormControl('Property 1'),
      nombre: new FormControl('Property 1'), // Alias para compatibilidad
      
      // Descripción y dirección de la propiedad
      description: new FormControl(null),
      country: new FormControl(null),
      stateRegion: new FormControl(null),
      city: new FormControl(null),
      neighborhood: new FormControl(null),
      postalCode: new FormControl(null),
      street: new FormControl(null),
      streetNumber: new FormControl(null),
      floor: new FormControl(null),
      googleMapsIframe: new FormControl(null),
      
      // Características del Inmueble
      rooms: new FormControl(null, [Validators.min(1)]),
      bathrooms: new FormControl(null, [Validators.min(1)]),
      squareMeters: new FormControl(null, [Validators.min(1)]),
      exterior: new FormControl(false),
      elevator: new FormControl(false),
      penthouse: new FormControl(false),
      duplex: new FormControl(false),
      building: new FormControl(false),
      pool: new FormControl(false),
      nobleFacade: new FormControl(false),

      // Estado del Proyecto
      status: new FormControl('Under Study' as ProjectStatus),
      estado: new FormControl('Under Study' as ProjectStatus), // Alias para compatibilidad

      // Fechas Clave
      launchDate: new FormControl(null),
      purchaseDate: new FormControl(null),
      renovationStartDate: new FormControl(null),
      estimatedDuration: new FormControl(null, [Validators.min(1)]),
      actualDuration: new FormControl(null, [Validators.min(1)]),

      // Análisis de Rentabilidad
      targetTerm: new FormControl(null, [Validators.min(1)]),
      netSaleIncome: new FormControl(null, [Validators.min(0)]),
      grossSaleIncome: new FormControl(null, [Validators.min(0)]),
      capitalGain: new FormControl(null, [Validators.min(0)]),
      realEstateCommissionSale: new FormControl(null, [Validators.min(0)]),
      promoterIncome: new FormControl(null, [Validators.min(0)]),
      investorIncome: new FormControl(null, [Validators.min(0)]),
      projectProfit: new FormControl(null, [Validators.min(0)]),
      promoterProfit: new FormControl(null, [Validators.min(0)]),
      totalInvestorProfitability: new FormControl(null, [Validators.min(0)]),
      annualizedInvestorProfitability: new FormControl(null, [Validators.min(0)]),

      // Campos adicionales para rentabilidad (compatibilidad con new-project-general-info)
      estimatedROI: new FormControl(null, [Validators.min(0)]),
      actualROI: new FormControl(null, [Validators.min(0)]),
      estimatedIRR: new FormControl(null, [Validators.min(0)]),
      actualIRR: new FormControl(null, [Validators.min(0)]),

      // Inversión del Proyecto - Gastos de adquisición
      purchasePrice: new FormControl(null, [Validators.min(0)]),
      realEstateCommission: new FormControl(null, [Validators.min(0)]),
      fiscalTaxes: new FormControl(null, [Validators.min(0)]),
      notaryAgencyRegistration: new FormControl(null, [Validators.min(0)]),

      // Obra y otros gastos
      constructionCompany: new FormControl(null, [Validators.min(0)]),
      licensesLegalCosts: new FormControl(null, [Validators.min(0)]),
      infographics: new FormControl(null, [Validators.min(0)]),
      externalQuantitySurveyor: new FormControl(null, [Validators.min(0)]),
      furniture: new FormControl(null, [Validators.min(0)]),
      photographer: new FormControl(null, [Validators.min(0)]),
      otherExpenses: new FormControl(null, [Validators.min(0)]),
      unforeseenExpenses: new FormControl(null, [Validators.min(0)]),
      otherAdaptationExpenses: new FormControl(null, [Validators.min(0)]),

      // Totales
      developmentExecution: new FormControl(null, [Validators.min(0)]),
      domoblockManagement: new FormControl(null, [Validators.min(0)]),

      // Documentos Adicionales
      propertyRegistry: new FormControl(null),
      workReport1: new FormControl(null),
      workReport2: new FormControl(null),
      workReport3: new FormControl(null),
      finalWorkReport: new FormControl(null),
      loanSubscriptionAgreement: new FormControl(null),
      agentMandateContract: new FormControl(null),

      // Galería de imágenes
      gallery: new FormArray<FormControl<string>>([]),

      // Atributos específicos
      attributes: new FormControl('{}'),
      atributos: new FormControl('{}'), // Alias para compatibilidad
      
      // Campos adicionales dinámicos (fechas y rentabilidad)
      keyDatesAdditionalFields: new FormControl([]),
      profitabilityAdditionalFields: new FormControl([]),
      
        // Secciones financieras (como array de objetos) - cada propiedad tiene las suyas
        financialSections: new FormControl([]),
        
        // Eventos de calendario (como array de objetos) - inicializados con los por defecto
        calendarEvents: new FormControl(this.projectAdapter.createDefaultCalendarEvents({})),
        
        // Documentos (como array de objetos) - cada propiedad tiene los suyos
        documents: new FormControl([])
    })
  }


  // Getters para campos principales del proyecto (compartidos)
  get title() { return this.formNewNft?.get('title') as FormControl || null; }
  get developer() { return this.formNewNft?.get('developer'); }
  get country() { return this.formNewNft?.get('country'); }
  get stateRegion() { return this.formNewNft?.get('stateRegion'); }
  get city() { return this.formNewNft?.get('city'); }
  get neighborhood() { return this.formNewNft?.get('neighborhood'); }
  get postalCode() { return this.formNewNft?.get('postalCode'); }
  get street() { return this.formNewNft?.get('street'); }
  get googleMapsIframe() { return this.formNewNft?.get('googleMapsIframe'); }
  get description() { return this.formNewNft?.get('description'); }
  get activationDate() { return this.formNewNft?.get('activationDate'); }
  get estimatedDeliveryPeriod() { return this.formNewNft?.get('estimatedDeliveryPeriod'); }
  get annualProfitability() { return this.formNewNft?.get('annualProfitability'); }
  get tokenPrice() { return this.formNewNft?.get('tokenPrice'); }
  get minimumInvestment() { return this.formNewNft?.get('minimumInvestment'); }
  get amountToSell() { return this.formNewNft?.get('amountToSell'); }
  get stableCoinAddress() { return this.formNewNft?.get('stableCoinAddress'); }
  get beneficiaryAddress() { return this.formNewNft?.get('beneficiaryAddress'); }
  get aggregatorStableCoinDollar() { return this.formNewNft?.get('aggregatorStableCoinDollar'); }
  get urlWhitepapperPdf() { return this.formNewNft?.get('urlWhitepapperPdf'); }
  get urlDosierPdf() { return this.formNewNft?.get('urlDosierPdf'); }
  get tokenInfoPdfUrl() { return this.formNewNft?.get('tokenInfoPdfUrl'); }
  get mainImageUrl() { return this.formNewNft?.get('mainImageUrl'); }
  get toBlockchain() { return this.formNewNft?.get('toBlockchain'); }
  get onlyInvestors() { return this.formNewNft?.get('onlyInvestors'); }
  get percentageToPrivateSale() { return this.formNewNft?.get('percentageToPrivateSale'); }
  get managingInvestments() { return this.formNewNft?.get('managingInvestments'); }
  get tokenName() { return this.formNewNft?.get('tokenName'); }
  get tokenSymbol() { return this.formNewNft?.get('tokenSymbol'); }
  get propertyType() { return this.formNewNft?.get('propertyType'); }
  get projectInfo() { return this.formNewNft?.get('projectInfo'); }

  // Getters para el array de propiedades
  get propertiesArray() { return this.formNewNft?.get('properties') as FormArray; }
  get activeProperty() { 
    const array = this.propertiesArray;
    if (array && array.length > 0 && this.activeViviendaIndex >= 0 && this.activeViviendaIndex < array.length) {
      return array.at(this.activeViviendaIndex) as FormGroup;
    }
    return null;
  }
  
  // Alias para compatibilidad
  get viviendasArray() { return this.propertiesArray; }
  get activeVivienda() { return this.activeProperty; }

  // Getters para la propiedad activa (delegación a la propiedad actual)
  get floor() { return this.activeProperty?.get('floor'); }
  get rooms() { return this.activeProperty?.get('rooms'); }
  get bathrooms() { return this.activeProperty?.get('bathrooms'); }
  get squareMeters() { return this.activeProperty?.get('squareMeters'); }
  get exterior() { return this.activeProperty?.get('exterior'); }
  get elevator() { return this.activeProperty?.get('elevator'); }
  get penthouse() { return this.activeProperty?.get('penthouse'); }
  get duplex() { return this.activeProperty?.get('duplex'); }
  get building() { return this.activeProperty?.get('building'); }
  get pool() { return this.activeProperty?.get('pool'); }
  get nobleFacade() { return this.activeProperty?.get('nobleFacade'); }
  get status() { return this.activeProperty?.get('status'); }
  get launchDate() { return this.activeProperty?.get('launchDate'); }
  get purchaseDate() { return this.activeProperty?.get('purchaseDate'); }
  get renovationStartDate() { return this.activeProperty?.get('renovationStartDate'); }
  get estimatedDuration() { return this.activeProperty?.get('estimatedDuration'); }
  get actualDuration() { return this.activeProperty?.get('actualDuration'); }
  get targetTerm() { return this.activeProperty?.get('targetTerm'); }
  get netSaleIncome() { return this.activeProperty?.get('netSaleIncome'); }
  get grossSaleIncome() { return this.activeProperty?.get('grossSaleIncome'); }
  get capitalGain() { return this.activeProperty?.get('capitalGain'); }
  get realEstateCommissionSale() { return this.activeProperty?.get('realEstateCommissionSale'); }
  get promoterIncome() { return this.activeProperty?.get('promoterIncome'); }
  get investorIncome() { return this.activeProperty?.get('investorIncome'); }
  get projectProfit() { return this.activeProperty?.get('projectProfit'); }
  get promoterProfit() { return this.activeProperty?.get('promoterProfit'); }
  get totalInvestorProfitability() { return this.activeProperty?.get('totalInvestorProfitability'); }
  get annualizedInvestorProfitability() { return this.activeProperty?.get('annualizedInvestorProfitability'); }
  get purchasePrice() { return this.activeProperty?.get('purchasePrice'); }
  get realEstateCommission() { return this.activeProperty?.get('realEstateCommission'); }
  get fiscalTaxes() { return this.activeProperty?.get('fiscalTaxes'); }
  get notaryAgencyRegistration() { return this.activeProperty?.get('notaryAgencyRegistration'); }
  get constructionCompany() { return this.activeProperty?.get('constructionCompany'); }
  get licensesLegalCosts() { return this.activeProperty?.get('licensesLegalCosts'); }
  get infographics() { return this.activeProperty?.get('infographics'); }
  get externalQuantitySurveyor() { return this.activeProperty?.get('externalQuantitySurveyor'); }
  get furniture() { return this.activeProperty?.get('furniture'); }
  get photographer() { return this.activeProperty?.get('photographer'); }
  get otherExpenses() { return this.activeProperty?.get('otherExpenses'); }
  get unforeseenExpenses() { return this.activeProperty?.get('unforeseenExpenses'); }
  get otherAdaptationExpenses() { return this.activeProperty?.get('otherAdaptationExpenses'); }
  get developmentExecution() { return this.activeProperty?.get('developmentExecution'); }
  get domoblockManagement() { return this.activeProperty?.get('domoblockManagement'); }
  get propertyRegistry() { return this.activeProperty?.get('propertyRegistry'); }
  get workReport1() { return this.activeProperty?.get('workReport1'); }
  get workReport2() { return this.activeProperty?.get('workReport2'); }
  get workReport3() { return this.activeProperty?.get('workReport3'); }
  get finalWorkReport() { return this.activeProperty?.get('finalWorkReport'); }
  get loanSubscriptionAgreement() { return this.activeProperty?.get('loanSubscriptionAgreement'); }
  get attributes() { return this.activeProperty?.get('attributes'); }
  get gallery() { return this.activeProperty?.get('gallery') as FormArray; }

  // Métodos para hacer los checkboxes mutuamente excluyentes
  onManagingInvestmentsChange(event: any) {
    if (event.target.checked) {
      this.onlyInvestors?.patchValue(false);
    }
  }

  onOnlyInvestorsChange(event: any) {
    if (event.target.checked) {
      this.managingInvestments?.patchValue(false);
    }
  }

  // Método para manejar el cambio del checkbox de viviendas múltiples (eliminado - ahora siempre se manejan múltiples viviendas)

  // Métodos para manejar selección dinámica de campos
  toggleCampoSeleccionado(campoId: string): void {
    const index = this.camposSeleccionados.indexOf(campoId);
    
    if (index > -1) {
      // Si está seleccionado, lo removemos
      this.camposSeleccionados.splice(index, 1);
    } else {
      // Si no está seleccionado y no hemos alcanzado el máximo
      if (this.camposSeleccionados.length < 6) {
        this.camposSeleccionados.push(campoId);
      } else {
        // Mostrar mensaje de que se ha alcanzado el máximo
        Swal.fire({
          title: 'Máximo alcanzado',
          text: 'Solo puedes seleccionar un máximo de 6 campos',
          icon: 'warning',
          confirmButtonText: 'Entendido'
        });
      }
    }
  }

  isCampoSeleccionado(campoId: string): boolean {
    return this.camposSeleccionados.includes(campoId);
  }

  getCamposSeleccionados() {
    return this.camposDisponibles.filter(campo => 
      this.camposSeleccionados.includes(campo.id)
    );
  }

  getCampoPorId(campoId: string) {
    return this.camposDisponibles.find(campo => campo.id === campoId);
  }

  // Métodos para cargar datos del proyecto en modo edición
  loadProjectData(): void {
    if (!this.projectToEdit) return;

    // Detectar si es un proyecto antiguo (legacy) basado en la estructura de datos
    const isLegacyProject = this.projectToEdit.mainImage && !this.projectToEdit.mainImageUrl;
    
    console.log('­ƒöì Detectando tipo de proyecto...');
    console.log('­ƒöì Es proyecto legacy:', isLegacyProject);
    console.log('­ƒöì Datos originales:', this.projectToEdit);

    let projectData = this.projectToEdit;
    
    // Si es un proyecto legacy, usar el adaptador para normalizar los datos
    if (isLegacyProject) {
      console.log('📦 Adaptando proyecto legacy...');
      try {
        const adaptedProject = this.projectAdapter.adaptLegacyProject(this.projectToEdit);
        // Actualizar this.projectToEdit con el proyecto adaptado para que loadViviendasOrAttributes tenga los datos correctos
        this.projectToEdit = adaptedProject;
        projectData = adaptedProject;
        console.log('✅ Proyecto adaptado:', this.projectToEdit);
      } catch (e) {
        console.error('❌ Error adaptando proyecto legacy:', e);
      }
    }

    // Cargar índices de la propiedad principal e imagen de portada
    this.mainPropertyIndex = projectData.mainPropertyIndex ?? 0;
    this.mainPropertyCoverIndex = projectData.mainPropertyCoverIndex ?? 0;

    // Cargar datos principales del proyecto (compatible con estructura antigua)
    this.title?.patchValue(projectData.title);
    this.developer?.patchValue(projectData.developer || projectData.company);
    this.country?.patchValue(projectData.country);
    this.stateRegion?.patchValue(projectData.stateRegion || projectData.stateCCAAProvince);
    this.city?.patchValue(projectData.city || projectData.location);
    this.neighborhood?.patchValue(projectData.neighborhood);
    this.postalCode?.patchValue(projectData.postalCode || projectData.cp);
    this.street?.patchValue(projectData.street);
    this.googleMapsIframe?.patchValue(projectData.googleMapsIframe || projectData.iframeGoogleMaps);
    this.description?.patchValue(projectData.description);
    this.estimatedDeliveryPeriod?.patchValue(projectData.estimatedDeliveryPeriod || projectData.estimatedDeliveryTime);
    this.annualProfitability?.patchValue(projectData.annualProfitability || projectData.annualReturn);
    this.amountToSell?.patchValue(projectData.amountToSell);
    const rawPrice = projectData.tokenPrice ?? projectData.priceToken;
    this.tokenPrice?.patchValue(rawPrice !== undefined && rawPrice !== null ? rawPrice / 100 : null);
    this.minimumInvestment?.patchValue(projectData.minimumInvestment);
    this.stableCoinAddress?.patchValue(projectData.stableCoinAddress);
    this.beneficiaryAddress?.patchValue(projectData.beneficiaryAddress);
    this.aggregatorStableCoinDollar?.patchValue(projectData.aggregatorStableCoinDollar || projectData.aggregatorStableCoinDolar || '0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D');
    this.onlyInvestors?.patchValue(projectData.onlyInvestors || projectData.onlyInversors);
    this.percentageToPrivateSale?.patchValue(projectData.percentageToPrivateSale);
    this.tokenName?.patchValue(projectData.tokenName || projectData.nameTokens);
    this.tokenSymbol?.patchValue(projectData.tokenSymbol || projectData.symbolTokens);
    this.propertyType?.patchValue(projectData.propertyType || 'House Flipping');
    this.projectInfo?.patchValue(projectData.projectInfo || projectData.infoProyecto);
    this.managingInvestments?.patchValue(projectData.managingInvestments || false);
    this.toBlockchain?.patchValue(projectData.toBlockchain || projectData.blockchain || false);

    // Cargar campos específicos de la estructura antigua
    this.formNewNft.patchValue({
      company: projectData.company,
      location: projectData.location,
      cp: projectData.cp,
      iframeGoogleMaps: projectData.iframeGoogleMaps,
      images: projectData.images || [],
      infoProyecto: projectData.infoProyecto,
      mainImage: projectData.mainImage,
      urlDosierPdf: projectData.urlDosierPdf,
      urlInfoTokenPdf: projectData.urlInfoTokenPdf,
      urlWhitepapperPdf: projectData.urlWhitepapperPdf,
      nameTokens: projectData.nameTokens,
      symbolTokens: projectData.symbolTokens,
      propertyType: projectData.propertyType || 'House Flipping',
      priceToken: projectData.priceToken,
      annualReturn: projectData.annualReturn,
      estimatedDeliveryTime: projectData.estimatedDeliveryTime,
      blockchain: projectData.blockchain,
      onlyInversors: projectData.onlyInversors,
      projectWallet: projectData.projectWallet,
      sellerAddress: projectData.sellerAddress,
      tokensAddress: projectData.tokensAddress,
      dividendsAddress: projectData.dividendsAddress,
      NftID: projectData.NftID,
      endOfSale: projectData.endOfSale,
      hoursToSell: projectData.hoursToSell,
      numberInvestors: projectData.numberInvestors,
      amountSold: projectData.amountSold,
      reserves: projectData.reserves,
      lastStatusUpdate: projectData.lastStatusUpdate,
      proyectStatus: projectData.proyectStatus,
      hide: projectData.hide
    });

    // Manejar fecha de activación con try-catch para prevenir crashes y usar fecha actual si falta
    try {
      let date = new Date();
      if (projectData.activationDate) {
        if (projectData.activationDate.toDate) {
          date = projectData.activationDate.toDate();
        } else if (projectData.activationDate instanceof Date) {
          date = projectData.activationDate;
        } else {
          date = new Date(projectData.activationDate);
        }
      }
      
      if (isNaN(date.getTime())) {
        date = new Date();
      }
      
      const tzoffset = (new Date()).getTimezoneOffset() * 60000;
      const localISOTime = new Date(date.getTime() - tzoffset).toISOString().slice(0, 16);
      this.activationDate?.patchValue(localISOTime);
    } catch (e) {
      console.error('Error parseando activationDate:', e);
      // Fallback in case of unexpected exceptions to prevent validation missing error
      const fallbackDate = new Date();
      const tzoffset = fallbackDate.getTimezoneOffset() * 60000;
      this.activationDate?.patchValue(new Date(fallbackDate.getTime() - tzoffset).toISOString().slice(0, 16));
    }

    // Cargar documentos
    if (projectData.urlWhitepapperPdf) {
      this.whitePaper = projectData.urlWhitepapperPdf;
      this.formNewNft.get('urlWhitepapperPdf')?.setValue(this.whitePaper);
    }
    if (projectData.urlDosierPdf) {
      this.dosier = projectData.urlDosierPdf;
      this.formNewNft.get('urlDosierPdf')?.setValue(this.dosier);
    }
    if (projectData.tokenInfoPdfUrl || projectData.urlInfoTokenPdf) {
      this.infoToken = projectData.tokenInfoPdfUrl || projectData.urlInfoTokenPdf;
      this.formNewNft.get('tokenInfoPdfUrl')?.setValue(this.infoToken);
    }

    // Cargar imagen principal
    console.log('­ƒöì Cargando imagen principal...');
    console.log('­ƒöì projectData.mainImageUrl:', projectData.mainImageUrl);
    if (projectData.mainImageUrl) {
      this.fotoMain = projectData.mainImageUrl;
      this.mainImageUrl?.setValue(projectData.mainImageUrl);
      console.log('Ô£à Imagen principal cargada:', this.fotoMain);
    } else {
      console.log('ÔØî No hay imagen principal en el proyecto');
    }

    // Cargar viviendas o atributos según el tipo de proyecto
    this.loadViviendasOrAttributes();

    // Configurar campos de solo lectura después de cargar los datos
    this.setupReadonlyFields();

    // Intentar sincronizar documentos desde Storage si hubo fallos de guardado en la DB
    if (this.isEditMode && this.id) {
      this.syncDocumentsFromStorage();
    }
  }

  // Método para sincronizar documentos huérfanos desde Firebase Storage
  private async syncDocumentsFromStorage(): Promise<boolean> {
    if (!this.id) return false;
    
    let hasRecoveries = false;
    console.log('[SYNC] Iniciando verificación de documentos huérfanos en Storage...');
    
    // Fijamos la propiedad activa al inicio para evitar condition races si el user interactúa con pestañas
    const safeIndex = this.getSafeMainPropertyIndex(this.propertiesArray.length);
    const activeProp = this.propertiesArray.at(safeIndex) as FormGroup | null;
    const currentDocs = activeProp ? (activeProp.get('documents')?.value || []) : [];
    
    const docTypesToRecover = [
      { key: 'urlWhitepapperPdf', fallback: 'Whitepaper.pdf', inRootForm: true },
      { key: 'urlDosierPdf', fallback: 'Dossier.pdf', inRootForm: true },
      { key: 'tokenInfoPdfUrl', fallback: 'InfoToken.pdf', inRootForm: true },
      { key: 'propertyRegistry', fallback: 'Nota_Simple.pdf', inRootForm: false },
      { key: 'loanSubscriptionAgreement', fallback: 'Acuerdo_Prestamo.pdf', inRootForm: false }
    ];

    // Mapear los promesas a evaluar simultáneamente
    const verifications = docTypesToRecover.map(async (doc) => {
      // Chequeo robusto dependiendo de dónde habite la variable nativa
      const controlValue = doc.inRootForm 
        ? this.formNewNft.get(doc.key)?.value 
        : activeProp?.get(doc.key)?.value;
        
      // O si el array local ya contiene alguna evidencia
      const inArray = currentDocs.some((d: any) => d.url && controlValue && d.url === controlValue);

      if (!controlValue || !inArray) {
        try {
          const folderRef = this.storage.ref(`investments/${this.id}/documents/${doc.key}`);
          const result = await folderRef.listAll().toPromise();
          
          if (result && result.items && result.items.length > 0) {
            const latestFile = result.items[result.items.length - 1];
            const url = await latestFile.getDownloadURL();
            
            console.log(`[SYNC] Recuperado documento huérfano desde Storage: ${doc.key}`);
            hasRecoveries = true;
            
            // Inyectar en cachés según ubicación
            if (doc.key === 'urlWhitepapperPdf') { this.whitePaper = url; this.formNewNft.get(doc.key)?.setValue(url); }
            if (doc.key === 'urlDosierPdf') { this.dosier = url; this.formNewNft.get(doc.key)?.setValue(url); }
            if (doc.key === 'tokenInfoPdfUrl') { this.infoToken = url; this.formNewNft.get(doc.key)?.setValue(url); }
            if (doc.key === 'propertyRegistry' && activeProp) activeProp.get('propertyRegistry')?.setValue(url);
            if (doc.key === 'loanSubscriptionAgreement' && activeProp) activeProp.get('loanSubscriptionAgreement')?.setValue(url);

            // Inyectar en Array de UI 
            if (!inArray && activeProp) {
              const updatedDocs = [...(activeProp.get('documents')?.value || []), {
                id: `doc_sync_${Date.now()}_${Math.random().toString(36).substr(2, 5)}`,
                name: latestFile.name || doc.fallback,
                type: 'pdf',
                url: url,
                sectionType: 'proyecto',
                uploadDate: new Date().toISOString()
              }];
              activeProp.get('documents')?.setValue(updatedDocs, {emitEvent: false});
            }
          }
        } catch (error: any) {
          if (error?.code === 'storage/unauthorized') {
            console.warn(`[SYNC] Permisos denegados (Storage) al intentar listar documentos para: ${doc.key}. Ignorando...`);
          }
        }
      }
    });

    const results = await Promise.allSettled(verifications);
    
    // Hardening: Logging explícito de fallos desconocidos no absorbidos por catch interno
    results.forEach((res, idx) => {
      if (res.status === 'rejected') {
        const err = res.reason;
        if (err?.code !== 'storage/unauthorized' && err?.code !== 'storage/object-not-found') {
          console.error(`[SYNC] Fallo anómalo reportado por Firebase Storage en index [${idx}]:`, err);
        }
      }
    });
    
    if (hasRecoveries) {
      console.log('[SYNC] Reconstrucción de Storage a Formulario completada.');
    }
    return hasRecoveries;
  }

  // Método para cargar propiedades o atributos según el tipo de proyecto
  loadViviendasOrAttributes(): void {
    if (!this.projectToEdit) {
      this.initializeEmptyProperty();
      return;
    }

    console.log('🔍 ========== VERIFICANDO ESTRUCTURA DEL PROYECTO ==========');
    console.log('🔍 Proyecto completo:', JSON.stringify(this.projectToEdit, null, 2));
    console.log('🔍 Verificando estructura del proyecto:', {
      hasProperties: !!this.projectToEdit.properties,
      propertiesLength: this.projectToEdit.properties?.length,
      propertiesIsArray: Array.isArray(this.projectToEdit.properties),
      propertiesType: typeof this.projectToEdit.properties,
      propertiesValue: this.projectToEdit.properties,
      hasViviendas: !!this.projectToEdit.viviendas,
      hasAttributes: !!this.projectToEdit.attributes,
      fullProject: this.projectToEdit
    });

    // Verificar si es un proyecto nuevo (con propiedades) o antiguo (con atributos)
    const hasProperties = this.projectToEdit.properties && Array.isArray(this.projectToEdit.properties) && this.projectToEdit.properties.length > 0;
    const hasViviendas = this.projectToEdit.viviendas && Array.isArray(this.projectToEdit.viviendas) && this.projectToEdit.viviendas.length > 0;
    
    // El adapter convierte attributes a string, por lo que verificamos ambos formatos
    const hasAttributesObj = this.projectToEdit.attributes && typeof this.projectToEdit.attributes === 'object' && this.projectToEdit.attributes !== null && Object.keys(this.projectToEdit.attributes).length > 0;
    const hasAttributesStr = this.projectToEdit.attributes && typeof this.projectToEdit.attributes === 'string' && this.projectToEdit.attributes.trim() !== '' && this.projectToEdit.attributes !== '{}';
    const hasAttributes = hasAttributesObj || hasAttributesStr;
    
    // Validar si fue adaptado recientemente y sus atributos location fueron movidos de raiz a ProjectDetail raiz
    const isAdaptedLegacy = !hasProperties && !hasViviendas && (hasAttributes || this.projectToEdit.country || this.projectToEdit.city || this.projectToEdit.street);

    console.log('🔍 Resultados de verificación:', {
      hasProperties,
      hasViviendas,
      hasAttributes,
      isAdaptedLegacy
    });

    if (hasProperties) {
      // Proyecto nuevo con propiedades
      console.log('📦 Cargando propiedades desde proyecto...');
      this.loadPropertiesFromProject();
    } else if (hasViviendas) {
      // Proyecto con viviendas (compatibilidad)
      console.log('📦 Cargando viviendas desde proyecto...');
      this.loadViviendasFromProject();
    } else if (isAdaptedLegacy) {
      // Proyecto antiguo con atributos o migrado desde DB adaptada
      console.log('📦 Migrando proyecto legacy a propiedad...');
      this.migrateLegacyProjectToProperty();
    } else {
      // Proyecto sin datos específicos - inicializar con propiedad vacía
      console.log('📦 Inicializando propiedad vacía...');
      this.initializeEmptyProperty();
    }
  }

  // Cargar propiedades desde proyecto nuevo
  loadPropertiesFromProject(): void {
    console.log('📦 ========== LOAD PROPERTIES FROM PROJECT ==========');
    console.log('📦 projectToEdit:', this.projectToEdit);
    console.log('📦 projectToEdit.properties:', this.projectToEdit?.properties);
    console.log('📦 ¿properties existe?', !!this.projectToEdit?.properties);
    console.log('📦 ¿properties es array?', Array.isArray(this.projectToEdit?.properties));
    console.log('📦 Tipo de properties:', typeof this.projectToEdit?.properties);
    
    if (!this.projectToEdit || !this.projectToEdit.properties || !Array.isArray(this.projectToEdit.properties)) {
      console.error('❌ Error: No se pueden cargar properties - proyecto o properties inválido');
      console.error('❌ projectToEdit:', this.projectToEdit);
      console.error('❌ properties value:', this.projectToEdit?.properties);
      this.initializeEmptyProperty();
      return;
    }

    console.log('📦 ✅ Validación OK - Cargando', this.projectToEdit.properties.length, 'propiedades...');
    console.log('📦 Properties array completo:', JSON.stringify(this.projectToEdit.properties, null, 2));
    this.propertiesArray.clear();
    
    this.projectToEdit.properties.forEach((property: any, index: number) => {
      console.log(`📦 ========== Cargando propiedad ${index + 1} ==========`);
      console.log(`📦 Property ${index} completa:`, JSON.stringify(property, null, 2));
      const propertyForm = this.createPropertyFormGroup();
      
      // Cargar datos básicos
      propertyForm.patchValue({
        id: property.id || `${Date.now()}_${index}`,
        name: property.name || `Property ${index + 1}`,
        
        // Características del inmueble
        floor: property.floor,
        rooms: property.rooms,
        bathrooms: property.bathrooms,
        squareMeters: property.squareMeters,
        exterior: property.exterior || false,
        elevator: property.elevator || false,
        penthouse: property.penthouse || false,
        duplex: property.duplex || false,
        building: property.building || false,
        pool: property.pool || false,
        nobleFacade: property.nobleFacade || false,

        // Estado
        status: property.status || 'Under Study',

        // Fechas clave (compatibilidad con formato antiguo y nuevo)
        launchDate: this.toDatetimeLocalString(property.keyDates?.launchDate || property.launchDate),
        purchaseDate: property.keyDates?.purchaseDate || property.purchaseDate,
        renovationStartDate: property.keyDates?.renovationStartDate || property.renovationStartDate,
        estimatedDuration: property.keyDates?.estimatedDuration || property.estimatedDuration,
        actualDuration: property.keyDates?.actualDuration || property.actualDuration,

        // Análisis financiero (compatibilidad con formato antiguo y nuevo)
        targetTerm: property.financialAnalysis?.targetTerm || property.targetTerm,
        netSaleIncome: property.financialAnalysis?.netSaleIncome || property.netSaleIncome,
        grossSaleIncome: property.financialAnalysis?.grossSaleIncome || property.grossSaleIncome,
        capitalGain: property.financialAnalysis?.capitalGain || property.capitalGain,
        realEstateCommissionSale: property.financialAnalysis?.realEstateCommissionSale || property.realEstateCommissionSale,
        promoterIncome: property.financialAnalysis?.promoterIncome || property.promoterIncome,
        investorIncome: property.financialAnalysis?.investorIncome || property.investorIncome,
        projectProfit: property.financialAnalysis?.projectProfit || property.projectProfit,
        promoterProfit: property.financialAnalysis?.promoterProfit || property.promoterProfit,
        totalInvestorProfitability: property.financialAnalysis?.totalInvestorProfitability || property.totalInvestorProfitability,
        annualizedInvestorProfitability: property.financialAnalysis?.annualizedInvestorProfitability || property.annualizedInvestorProfitability,

        // Inversión (compatibilidad con formato antiguo y nuevo)
        purchasePrice: property.investmentBreakdown?.acquisitionCosts?.purchasePrice || property.purchasePrice,
        realEstateCommission: property.investmentBreakdown?.acquisitionCosts?.realEstateCommission || property.realEstateCommission,
        fiscalTaxes: property.investmentBreakdown?.acquisitionCosts?.fiscalTaxes || property.fiscalTaxes,
        notaryAgencyRegistration: property.investmentBreakdown?.acquisitionCosts?.notaryAgencyRegistration || property.notaryAgencyRegistration,
        constructionCompany: property.investmentBreakdown?.constructionCosts?.constructionCompany || property.constructionCompany,
        licensesLegalCosts: property.investmentBreakdown?.constructionCosts?.licensesLegalCosts || property.licensesLegalCosts,
        infographics: property.investmentBreakdown?.constructionCosts?.infographics || property.infographics,
        externalQuantitySurveyor: property.investmentBreakdown?.constructionCosts?.externalQuantitySurveyor || property.externalQuantitySurveyor,
        furniture: property.investmentBreakdown?.constructionCosts?.furniture || property.furniture,
        photographer: property.investmentBreakdown?.constructionCosts?.photographer || property.photographer,
        otherExpenses: property.investmentBreakdown?.constructionCosts?.otherExpenses || property.otherExpenses,
        unforeseenExpenses: property.investmentBreakdown?.constructionCosts?.unforeseenExpenses || property.unforeseenExpenses,
        otherAdaptationExpenses: property.investmentBreakdown?.constructionCosts?.otherAdaptationExpenses || property.otherAdaptationExpenses,
        developmentExecution: property.investmentBreakdown?.developmentExecution || property.developmentExecution,
        domoblockManagement: property.investmentBreakdown?.domoblockManagement || property.domoblockManagement,

        // Documentos adicionales (compatibilidad con formato antiguo y nuevo)
        propertyRegistry: property.additionalDocuments?.propertyRegistry || property.propertyRegistry,
        workReport1: property.additionalDocuments?.workReport1 || property.workReport1,
        workReport2: property.additionalDocuments?.workReport2 || property.workReport2,
        workReport3: property.additionalDocuments?.workReport3 || property.workReport3,
        finalWorkReport: property.additionalDocuments?.finalWorkReport || property.finalWorkReport,
        loanSubscriptionAgreement: property.additionalDocuments?.loanSubscriptionAgreement || property.loanSubscriptionAgreement,
        agentMandateContract: property.additionalDocuments?.agentMandateContract || property.agentMandateContract,

        // Galería - inicializar FormArray
        // Documentos de galerilla - inicializado desde FormArray
        // gallery: this.initializeGalleryFormArray(property.gallery || []),

        // Atributos
        attributes: property.attributes || '{}',

        // Descripción
        description: property.description || null,

        // Ubicación y dirección
        country: property.location?.country || property.country || null,
        stateRegion: property.location?.stateRegion || property.stateRegion || null,
        city: property.location?.city || property.city || null,
        neighborhood: property.location?.neighborhood || property.neighborhood || null,
        postalCode: property.location?.postalCode || property.postalCode || null,
        street: property.location?.street || property.street || null,
        streetNumber: property.location?.streetNumber || property.streetNumber || null,
        googleMapsIframe: property.location?.googleMapsIframe || property.googleMapsIframe || null,
        
        // ROI e IRR (Duración y rentabilidad)
        estimatedROI: property.financialAnalysis?.estimatedROI || property.estimatedROI || null,
        actualROI: property.financialAnalysis?.actualROI || property.actualROI || null,
        estimatedIRR: property.financialAnalysis?.estimatedIRR || property.estimatedIRR || null,
        actualIRR: property.financialAnalysis?.actualIRR || property.actualIRR || null,
        
        // Campos adicionales dinámicos (compatibilidad con formato antiguo y nuevo)
        keyDatesAdditionalFields: property.keyDates?.additionalFields || [],
        profitabilityAdditionalFields: property.financialAnalysis?.additionalFields || [],
        
          // Secciones financieras (guardar en el FormControl de cada propiedad)
          financialSections: this.safeParseFinancialSections(property),
          
          // Eventos de calendario (guardar en el FormControl de cada propiedad)
          calendarEvents: property.calendarEvents || [],

          // Documentos (como array de objetos) - cada propiedad tiene los suyos
          documents: this.mergeLegacyDocuments(property, index, this.projectToEdit)
      });

      // La formacion de la galeria de imagenes se debe setear con setControl, en lugar de patchValue
      const galleryArray = this.initializeGalleryFormArray(property.gallery || []);
      propertyForm.setControl('gallery', galleryArray);

      this.propertiesArray.push(propertyForm);
    });

    this.activeViviendaIndex = 0;
    
    // Cargar secciones financieras de la primera propiedad si existe
    if (this.propertiesArray.length > 0) {
      const firstPropertyForm = this.propertiesArray.at(0) as FormGroup;
      if (firstPropertyForm) {
        const savedSections = firstPropertyForm.get('financialSections')?.value;
        if (savedSections) {
          if (Array.isArray(savedSections) && savedSections.length > 0) {
            this.loadFinancialSectionsFromProperty(savedSections);
          } else if (typeof savedSections === 'string' && savedSections.trim() !== '') {
            this.loadFinancialSectionsFromProperty(savedSections);
          }
        } else {
          // Si no hay secciones guardadas, usar las por defecto
          this.financialSectionService.resetToDefaultSections();
        }
        
        // Cargar eventos de calendario de la primera propiedad si existe
        const savedCalendarEvents = firstPropertyForm.get('calendarEvents')?.value;
        if (savedCalendarEvents && Array.isArray(savedCalendarEvents) && savedCalendarEvents.length > 0) {
          this.loadCalendarEventsFromProperty(savedCalendarEvents);
        }
      }
    }
  }

  /**
   * Fusiona los documentos root o legacy en el array de documents para que aparezcan en la UI de la pestaña Documentación.
   */
  private mergeLegacyDocuments(property: any, index: number, projectData: any): any[] {
    let docs = [...(property.documents || [])];
    
    // Solo inyectar en la propiedad principal.
    if (index === this.getSafeMainPropertyIndex(projectData?.properties?.length || 0)) {
      // Dossier
      const dossierUrl = projectData.urlDosierPdf || this.dosier;
      if (dossierUrl && !this.hasDocumentSlot(docs, 'urlDosierPdf', ['dossier', 'dosier'])) {
        docs.push({ id: `doc_dossier_${Date.now()}`, name: 'Dossier.pdf', docType: 'urlDosierPdf', slot: 'urlDosierPdf', type: 'pdf', url: dossierUrl, sectionType: 'proyecto', uploadDate: new Date().toISOString() });
      }
      // Whitepaper
      const wpUrl = projectData.urlWhitepapperPdf || this.whitePaper;
      if (wpUrl && !this.hasDocumentSlot(docs, 'urlWhitepapperPdf', ['whitepaper', 'white paper'])) {
        docs.push({ id: `doc_wp_${Date.now()}`, name: 'Whitepaper.pdf', docType: 'urlWhitepapperPdf', slot: 'urlWhitepapperPdf', type: 'pdf', url: wpUrl, sectionType: 'proyecto', uploadDate: new Date().toISOString() });
      }
      // Info Token
      const tokenUrl = projectData.tokenInfoPdfUrl || projectData.urlInfoTokenPdf || this.infoToken;
      if (tokenUrl && !this.hasDocumentSlot(docs, 'tokenInfoPdfUrl', ['token', 'info'])) {
        docs.push({ id: `doc_token_${Date.now()}`, name: 'InfoToken.pdf', docType: 'tokenInfoPdfUrl', slot: 'tokenInfoPdfUrl', type: 'pdf', url: tokenUrl, sectionType: 'proyecto', uploadDate: new Date().toISOString() });
      }
      // Property Registry (Nota Simple)
      if (property.propertyRegistry && typeof property.propertyRegistry === 'string' && !this.hasDocumentSlot(docs, 'propertyRegistry', ['nota', 'registry'])) {
        docs.push({ id: `doc_registry_${Date.now()}`, name: 'Nota_Simple.pdf', docType: 'propertyRegistry', slot: 'propertyRegistry', type: 'pdf', url: property.propertyRegistry, sectionType: 'inmueble', uploadDate: new Date().toISOString() });
      }
      // Loan Subscription Agreement (Acuerdo de préstamo)
      if (property.loanSubscriptionAgreement && typeof property.loanSubscriptionAgreement === 'string' && !this.hasDocumentSlot(docs, 'loanSubscriptionAgreement', ['acuerdo', 'loan'])) {
        docs.push({ id: `doc_loan_${Date.now()}`, name: 'Acuerdo_Prestamo.pdf', docType: 'loanSubscriptionAgreement', slot: 'loanSubscriptionAgreement', type: 'pdf', url: property.loanSubscriptionAgreement, sectionType: 'proyecto', uploadDate: new Date().toISOString() });
      }
      // Agent Mandate Contract
      if (property.agentMandateContract && typeof property.agentMandateContract === 'string' && !this.hasDocumentSlot(docs, 'agentMandateContract', ['mandat', 'agent'])) {
        docs.push({ id: `doc_mandate_${Date.now()}`, name: 'Contrato_Mandato.pdf', docType: 'agentMandateContract', slot: 'agentMandateContract', type: 'pdf', url: property.agentMandateContract, sectionType: 'proyecto', uploadDate: new Date().toISOString() });
      }
    }
    
    return docs;
  }

  /**
   * Busca en el array de documentos por docType/slot estable primero y por nombre legacy como fallback.
   * Retorna la url o null si no existe. Permite limitar a un sectionType.
   */
  private findDocUrlByName(docs: any[], keywords: string[], sectionType?: string, docType?: string): string | null {
    if (!Array.isArray(docs)) return null;
    const filteredDocs = docs.filter((d: any) => !sectionType || d?.sectionType === sectionType);
    const slotMatch = docType
      ? filteredDocs.find((d: any) => d?.docType === docType || d?.slot === docType || d?.documentType === docType)
      : null;
    if (slotMatch) return slotMatch.url || null;

    const match = filteredDocs.find((d: any) => {
      const name = (d?.name || '').toLowerCase();
      return keywords.some(k => name.includes(k));
    });
    return match?.url || null;
  }

  private hasDocumentSlot(docs: any[], docType: string, fallbackKeywords: string[]): boolean {
    if (!Array.isArray(docs)) return false;
    return docs.some((d: any) => {
      if (d?.docType === docType || d?.slot === docType || d?.documentType === docType) return true;
      const name = (d?.name || '').toLowerCase();
      return fallbackKeywords.some(k => name.includes(k));
    });
  }

  /**
   * Carga las secciones financieras desde un string JSON
   */
  private loadFinancialSectionsFromProperty(financialSections: any[] | string): void {
    try {
      // Compatibilidad con formato antiguo (string JSON) y nuevo (array)
      let sections: any[] = [];
      
      if (typeof financialSections === 'string' && financialSections.trim() !== '') {
        // Formato antiguo: string JSON
        sections = JSON.parse(financialSections);
      } else if (Array.isArray(financialSections) && financialSections.length > 0) {
        // Formato nuevo: array directamente
        sections = financialSections;
      } else {
        return;
      }
      
      if (Array.isArray(sections) && sections.length > 0) {
        // Convertir las secciones a formato FinancialSection y cargarlas en el servicio
        const financialSections = sections.map((section: any) => ({
          id: section.id || this.generateFinancialId(),
          title: section.title || '',
          type: section.type || 'calculation',
          color: section.color || '#f09502',
          order: section.order !== undefined ? section.order : 0,
          isCollapsed: section.isCollapsed || false,
          fields: (section.fields || []).map((field: any) => ({
            id: field.id || this.generateFinancialId(),
            label: field.label || '',
            type: field.type || 'currency',
            value: field.value !== null && field.value !== undefined ? field.value : null,
            required: field.required || false,
            placeholder: field.placeholder || '',
            labelPercentage: field.labelPercentage
          })),
          subsections: (section.subsections || []).map((subsection: any) => ({
            id: subsection.id || this.generateFinancialId(),
            title: subsection.title || '',
            isFixed: subsection.isFixed || false,
            fields: (subsection.fields || []).map((field: any) => ({
              id: field.id || this.generateFinancialId(),
              label: field.label || '',
              type: field.type || 'currency',
              value: field.value !== null && field.value !== undefined ? field.value : null,
              required: field.required || false,
              placeholder: field.placeholder || '',
              labelPercentage: field.labelPercentage
            }))
          }))
        }));
        
        this.financialSectionService.setSections(financialSections);
      }
    } catch (error) {
      console.error('Error cargando secciones financieras desde propiedad:', error);
    }
  }

  /**
   * Genera un ID único para secciones financieras
   */
  private generateFinancialId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  /**
   * Carga los eventos de calendario desde una propiedad
   * Nota: Los eventos se cargarán automáticamente cuando el componente de calendario detecte el cambio en el FormControl
   */
  private loadCalendarEventsFromProperty(calendarEvents: any[]): void {
    try {
      if (!Array.isArray(calendarEvents) || calendarEvents.length === 0) {
        // Si no hay eventos, asegurarse de que el FormControl esté vacío
        const activePropertyForm = this.activeProperty;
        if (activePropertyForm) {
          activePropertyForm.get('calendarEvents')?.setValue([]);
        }
        return;
      }
      
      // Convertir los eventos a formato CalendarEvent
      const events = calendarEvents.map((event: any) => ({
        id: event.id || this.generateEventId(),
        title: event.title || '',
        description: event.description || '',
        startDate: event.startDate ? new Date(event.startDate) : new Date(),
        endDate: event.endDate ? new Date(event.endDate) : new Date(),
        icon: event.icon || '📅',
        status: event.status || 'pending',
        type: event.type || 'custom',
        color: event.color || '#6c757d',
        isEditable: event.isEditable !== undefined ? event.isEditable : true,
        order: event.order !== undefined ? event.order : 0,
        createdAt: event.createdAt ? new Date(event.createdAt) : new Date(),
        updatedAt: event.updatedAt ? new Date(event.updatedAt) : new Date()
      }));
      
      // Guardar en el FormControl - el componente de calendario los leerá automáticamente
      const activePropertyForm = this.activeProperty;
      if (activePropertyForm) {
        activePropertyForm.get('calendarEvents')?.setValue(events);
      }
    } catch (error) {
      console.error('Error cargando eventos de calendario desde propiedad:', error);
    }
  }

  // Cargar viviendas desde proyecto nuevo (compatibilidad)
  loadViviendasFromProject(): void {
    this.viviendasArray.clear();
    
    this.projectToEdit.viviendas.forEach((vivienda: any, index: number) => {
      const viviendaForm = this.createPropertyFormGroup();
      
      // Cargar datos básicos
      viviendaForm.patchValue({
        id: vivienda.id || `${Date.now()}_${index}`,
        name: vivienda.name || vivienda.nombre || `Property ${index + 1}`,
        nombre: vivienda.nombre || vivienda.name || `Property ${index + 1}`, // Alias para compatibilidad
        
        // Características del inmueble (Mapeo directo u original si existen)
        floor: vivienda.floor,
        rooms: vivienda.rooms || (vivienda.atributos ? JSON.parse(vivienda.atributos).habitaciones : null),
        bathrooms: vivienda.bathrooms || (vivienda.atributos ? JSON.parse(vivienda.atributos).banos : null),
        squareMeters: vivienda.squareMeters || (vivienda.atributos ? JSON.parse(vivienda.atributos).metros_cuadrados : null),
        exterior: vivienda.exterior || false,
        elevator: vivienda.elevator || false,
        penthouse: vivienda.penthouse || vivienda.atico || false,
        duplex: vivienda.duplex || false,
        building: vivienda.building || vivienda.edificio || false,
        pool: vivienda.pool || vivienda.piscina || false,
        nobleFacade: vivienda.nobleFacade || vivienda.fachadaSenorial || false,

        // Estado
        estado: vivienda.estado || 'En estudio',
        status: vivienda.status || vivienda.estado || 'En estudio',

        // Fechas clave
        fechaLanzamiento: vivienda.keyDates?.fechaLanzamiento || vivienda.keyDates?.launchDate,
        launchDate: this.toDatetimeLocalString(vivienda.launchDate || vivienda.keyDates?.launchDate || vivienda.keyDates?.fechaLanzamiento),
        
        fechaCompra: vivienda.keyDates?.fechaCompra || vivienda.keyDates?.purchaseDate,
        purchaseDate: vivienda.purchaseDate || vivienda.keyDates?.purchaseDate || vivienda.keyDates?.fechaCompra,
        
        fechaInicioReforma: vivienda.keyDates?.fechaInicioReforma || vivienda.keyDates?.renovationStartDate,
        renovationStartDate: vivienda.renovationStartDate || vivienda.keyDates?.renovationStartDate || vivienda.keyDates?.fechaInicioReforma,
        
        duracionEstimada: vivienda.keyDates?.duracionEstimada || vivienda.keyDates?.estimatedDuration,
        estimatedDuration: vivienda.estimatedDuration || vivienda.keyDates?.estimatedDuration || vivienda.keyDates?.duracionEstimada,
        
        duracionReal: vivienda.keyDates?.duracionReal || vivienda.keyDates?.actualDuration,
        actualDuration: vivienda.actualDuration || vivienda.keyDates?.actualDuration || vivienda.keyDates?.duracionReal,

        // Duración y rentabilidad (ROI, TIR)
        estimatedROI: vivienda.estimatedROI || vivienda.financialAnalysis?.estimatedROI || vivienda.financialAnalysis?.roiEstimado,
        actualROI: vivienda.actualROI || vivienda.financialAnalysis?.actualROI || vivienda.financialAnalysis?.roiReal,
        estimatedIRR: vivienda.estimatedIRR || vivienda.financialAnalysis?.estimatedIRR || vivienda.financialAnalysis?.tirEstimada,
        actualIRR: vivienda.actualIRR || vivienda.financialAnalysis?.actualIRR || vivienda.financialAnalysis?.tirReal,

        // Secciones Financieras (inyectadas si no existen)
        financialSections: vivienda.financialSections && vivienda.financialSections.length > 0  
          ? vivienda.financialSections 
          : this.generateDynamicSectionsFromLegacyData(vivienda),


        // Documentos adicionales
        notaSimple: vivienda.additionalDocuments?.notaSimple,
        informeObra1: vivienda.additionalDocuments?.informeObra1,
        informeObra2: vivienda.additionalDocuments?.informeObra2,
        informeObra3: vivienda.additionalDocuments?.informeObra3,
        informeFinObra: vivienda.additionalDocuments?.informeFinObra,
        acuerdoSubscripcionPrestamo: vivienda.additionalDocuments?.acuerdoSubscripcionPrestamo,
        agentMandateContract: vivienda.additionalDocuments?.agentMandateContract || vivienda.agentMandateContract,

        // Galería - inicializar FormArray
        gallery: this.initializeGalleryFormArray(vivienda.gallery || []),

        // Atributos
        atributos: vivienda.atributos || '{}'
      });

      this.viviendasArray.push(viviendaForm);
    });

    this.activeViviendaIndex = 0;
  }

  // Migrar proyecto antiguo a formato de propiedad
  migrateLegacyProjectToProperty(): void {
    this.propertiesArray.clear();
    
    const propertyForm = this.createPropertyFormGroup();
    
    // Convertir atributos antiguos a formato de propiedad
    const attributes = this.projectToEdit.attributes;
    const attributesString = this.formatLegacyAttributesToString(attributes);
    
    // Migrar imágenes del proyecto antiguo a la galería de la propiedad
    const galleryImages: string[] = [];
    if (this.projectToEdit.images && Array.isArray(this.projectToEdit.images)) {
      galleryImages.push(...this.projectToEdit.images);
    }
    
    // Migrar datos del proyecto antiguo a la propiedad
    propertyForm.patchValue({
      id: `${Date.now()}_0`,
      name: 'Main Property',
      nombre: 'Main Property', // Alias para compatibilidad
      
      // Migrar campos de dirección del proyecto a la propiedad
      description: this.projectToEdit.description,
      country: this.projectToEdit.country,
      stateRegion: this.projectToEdit.stateRegion || this.projectToEdit.stateCCAAProvince,
      city: this.projectToEdit.city || this.projectToEdit.location,
      neighborhood: this.projectToEdit.neighborhood,
      postalCode: this.projectToEdit.postalCode || this.projectToEdit.cp,
      street: this.projectToEdit.street,
      streetNumber: this.projectToEdit.streetNumber,
      floor: this.projectToEdit.floor,
      googleMapsIframe: this.projectToEdit.googleMapsIframe || this.projectToEdit.iframeGoogleMaps,
      
      // Caracteristicas del Inmueble (extraídas de attributes)
      rooms: attributes.habitaciones || attributes.rooms,
      bathrooms: attributes.banos || attributes.bathrooms,
      squareMeters: attributes.metros_cuadrados || attributes.squareMeters,
      exterior: attributes.exterior === 'Si' || attributes.exterior === true,
      elevator: attributes.ascensor === 'Si' || attributes.elevator === true,
      penthouse: attributes.atico === 'Si' || attributes.penthouse === true,
      duplex: attributes.duplex === 'Si' || attributes.duplex === true,
      building: attributes.edificio === 'Si' || attributes.building === true,
      pool: attributes.piscina === 'Si' || attributes.pool === true,
      nobleFacade: attributes.fachada_senorial === 'Si' || attributes.nobleFacade === true,
      
      // Migrar atributos específicos
      attributes: attributesString,
      atributos: attributesString, // Alias para compatibilidad

      // Fechas Clave
      launchDate: this.projectToEdit.launchDate || this.projectToEdit.fechaLanzamiento || this.projectToEdit.keyDates?.launchDate || this.projectToEdit.keyDates?.fechaLanzamiento,
      purchaseDate: this.projectToEdit.purchaseDate || this.projectToEdit.fechaCompra || this.projectToEdit.keyDates?.purchaseDate || this.projectToEdit.keyDates?.fechaCompra,
      renovationStartDate: this.projectToEdit.renovationStartDate || this.projectToEdit.fechaInicioReforma || this.projectToEdit.keyDates?.renovationStartDate || this.projectToEdit.keyDates?.fechaInicioReforma,
      estimatedDuration: this.projectToEdit.estimatedDuration || this.projectToEdit.duracionEstimada || this.projectToEdit.keyDates?.estimatedDuration || this.projectToEdit.keyDates?.duracionEstimada,
      actualDuration: this.projectToEdit.actualDuration || this.projectToEdit.duracionReal || this.projectToEdit.keyDates?.actualDuration || this.projectToEdit.keyDates?.duracionReal,

      // Duración y rentabilidad
      estimatedROI: this.projectToEdit.estimatedROI || this.projectToEdit.financialAnalysis?.estimatedROI || this.projectToEdit.financialAnalysis?.roiEstimado,
      actualROI: this.projectToEdit.actualROI || this.projectToEdit.financialAnalysis?.actualROI || this.projectToEdit.financialAnalysis?.roiReal,
      estimatedIRR: this.projectToEdit.estimatedIRR || this.projectToEdit.financialAnalysis?.estimatedIRR || this.projectToEdit.financialAnalysis?.tirEstimada,
      actualIRR: this.projectToEdit.actualIRR || this.projectToEdit.financialAnalysis?.actualIRR || this.projectToEdit.financialAnalysis?.tirReal,

      // Inyectar secciones financieras generadas a partir de legacy
      financialSections: this.generateDynamicSectionsFromLegacyData(this.projectToEdit)
    });

    // Inicializar FormArray de galería
    const galleryArray = this.initializeGalleryFormArray(galleryImages);
    propertyForm.setControl('gallery', galleryArray);

    this.propertiesArray.push(propertyForm);
    this.activeViviendaIndex = 0;
  }

  // Migrar proyecto antiguo a formato de vivienda (compatibilidad)
  migrateLegacyProjectToVivienda(): void {
    this.viviendasArray.clear();
    
    const viviendaForm = this.createPropertyFormGroup();
    
    // Convertir atributos antiguos a formato de vivienda
    const attributes = this.projectToEdit.attributes;
    const atributosString = this.formatLegacyAttributesToString(attributes);
    
    // Migrar imágenes del proyecto antiguo a la galería de la vivienda
    const galleryImages: string[] = [];
    if (this.projectToEdit.images && Array.isArray(this.projectToEdit.images)) {
      galleryImages.push(...this.projectToEdit.images);
    }
    
    viviendaForm.patchValue({
      id: `${Date.now()}_0`,
      name: 'Main Property',
      nombre: 'Main Property', // Alias para compatibilidad
      attributes: atributosString,
      atributos: atributosString // Alias para compatibilidad
    });

    // Inicializar FormArray de galería
    const galleryArray = this.initializeGalleryFormArray(galleryImages);
    viviendaForm.setControl('gallery', galleryArray);

    this.viviendasArray.push(viviendaForm);
    this.activeViviendaIndex = 0;
  }

  // Inicializar propiedad vacía
  initializeEmptyProperty(): void {
    this.propertiesArray.clear();
    this.propertiesArray.push(this.createPropertyFormGroup());
    this.activeViviendaIndex = 0;
  }

  // Inicializar vivienda vacía (compatibilidad)
  initializeEmptyVivienda(): void {
    this.viviendasArray.clear();
    this.viviendasArray.push(this.createPropertyFormGroup());
    this.activeViviendaIndex = 0;
  }

  // Formatear atributos antiguos a string
  formatLegacyAttributesToString(attributes: any): string {
    if (!attributes || Object.keys(attributes).length === 0) {
      return '{}';
    }

    return `{${Object.entries(attributes)
      .map(([key, value]) => `"${key}": ${typeof value === 'string' ? `"${value}"` : value}`)
      .join(', ')}}`;
  }

  // Método para verificar si un proyecto está en blockchain
  isProjectInBlockchain(): boolean {
    const isBoolTrue = this.projectToEdit?.blockchain === true || String(this.projectToEdit?.blockchain) === 'true';
    const hasContract = !!this.projectToEdit?.tokensAddress || !!this.projectToEdit?.contractAddress;
    return isBoolTrue || hasContract;
  }

  // Método para verificar si un campo está bloqueado (solo lectura)
  isFieldBlocked(fieldName: string): boolean {
    if (!this.isProjectInBlockchain()) {
      return false; // Si no está en blockchain, todos los campos son editables
    }

    // Campos que SÍ se pueden editar en proyectos en blockchain
    const editableFields = [
      'description',
      'urlWhitepapperPdf',
      'urlDosierPdf',
      'tokenInfoPdfUrl',
      'mainImageUrl',
      'projectInfo',
      'annualProfitability',
      'estimatedDeliveryPeriod'
    ];

    return !editableFields.includes(fieldName);
  }

  // Método para configurar campos de solo lectura
  setupReadonlyFields(): void {
    this.projectInBlockchain = this.isProjectInBlockchain();
    
    if (this.projectInBlockchain) {
      // Deshabilitar campos críticos para proyectos en blockchain.
      // Rentabilidad (annualProfitability) y duración (estimatedDeliveryPeriod) se mantienen
      // editables: no afectan al contrato y el equipo necesita poder ajustarlos tras el despliegue.
      const criticalFields = [
        'title', 'developer', 'country', 'stateRegion', 'city', 'neighborhood',
        'postalCode', 'street', 'googleMapsIframe',
        'amountToSell', 'tokenPrice', 'minimumInvestment',
        'stableCoinAddress', 'beneficiaryAddress', 'aggregatorStableCoinDollar',
        'toBlockchain', 'onlyInvestors', 'percentageToPrivateSale',
        'tokenName', 'tokenSymbol', 'propertyType', 'activationDate', 'managingInvestments'
      ];

      criticalFields.forEach(field => {
        const control = this.formNewNft.get(field);
        if (control) {
          control.disable();
        }
      });
    }
  }

  // Método para inicializar FormArray de galería con imágenes existentes
  private initializeGalleryFormArray(images: string[]): FormArray<FormControl<string>> {
    const galleryArray = new FormArray<FormControl<string>>([]);
    images.forEach(imageUrl => {
      if (imageUrl) {
        galleryArray.push(new FormControl<string>(imageUrl, { nonNullable: true }));
      }
    });
    return galleryArray;
  }

  // Métodos para manejar viviendas múltiples (ahora se manejan en los métodos principales)

  getAtributosJsonFromString(atributosString: string): Record<string, any> {
    const trimmedString = atributosString?.trim() || '{}';

    try {
      const sanitizedString =
        trimmedString.startsWith('{') && trimmedString.endsWith('}')
          ? trimmedString
          : `{${trimmedString}}`;

      // Parsear el JSON string
      const atributos = JSON.parse(sanitizedString);

      const atributosOrdenados: Record<string, any> = {};

      // Primero, añadir los atributos en un orden especifico
      this.ordenAtributos.forEach((key) => {
        if (key in atributos) {
          atributosOrdenados[key] = atributos[key];
          delete atributos[key];
        }
      });

      // Luego, añadir los atributos que quedan
      Object.assign(atributosOrdenados, atributos);

      return atributosOrdenados;
    } catch (error) {
      console.error("Error al analizar la cadena JSON en 'attributes':", error);
      return {};
    }
  }

  // Parse safe section to prevent JSON.parse crashes and auto-repair legacy piped labels
  safeParseFinancialSections(property: any): any[] {
    let parsedSections: any[] = [];
    if (property.financialSections && Array.isArray(property.financialSections)) {
      parsedSections = property.financialSections;
    } else if (property.financialSectionsRaw) {
      if (typeof property.financialSectionsRaw === 'string') {
        try {
          parsedSections = JSON.parse(property.financialSectionsRaw);
        } catch (e) {
          console.error('Error parsing financialSectionsRaw:', e);
        }
      } else {
        parsedSections = property.financialSectionsRaw;
      }
    }

    // Auto-repair manually formatted piped labels to restore the labelPercentage input boxes in Edit Mode
    if (Array.isArray(parsedSections)) {
      parsedSections.forEach(section => {
        if (Array.isArray(section.fields)) {
          section.fields.forEach((field: any) => this.repairLegacyLabelPercentage(field));
        }
        if (Array.isArray(section.subsections)) {
          section.subsections.forEach((sub: any) => {
            if (Array.isArray(sub.fields)) {
              sub.fields.forEach((field: any) => this.repairLegacyLabelPercentage(field));
            }
          });
        }
      });
    }

    return parsedSections;
  }

  /**
   * Automatically splits labels containing a pipe '|' character into a base label
   * and a labelPercentage, restoring the separated input boxes in the UI if the
   * user manually typed them as a single string.
   */
  private repairLegacyLabelPercentage(field: any): void {
    if (field.label && typeof field.label === 'string' && field.label.includes('|')) {
      if (field.labelPercentage === undefined || field.labelPercentage === null) {
        const parts = field.label.split('|');
        if (parts.length === 2) {
          const percentageStr = parts[1].replace('%', '').trim();
          const parsed = parseFloat(percentageStr.replace(',', '.')); // Soporte para comas si lo introducen a mano
          if (!isNaN(parsed)) {
            field.labelPercentage = parsed;
            field.label = parts[0].trim();
          }
        }
      }
    }
  }

  // Método para obtener todas las propiedades del formulario como array
  getAllPropertiesFromForm(): any[] {
    const properties: any[] = [];
    
      // Guardar las secciones financieras actuales del servicio en la propiedad activa antes de procesar todas
      const activePropertyForm = this.activeProperty;
      if (activePropertyForm) {
        const currentSections = this.serializeFinancialSections();
        activePropertyForm.get('financialSections')?.setValue(currentSections);
        
        // Guardar los eventos de calendario actuales del servicio en la propiedad activa
        const currentCalendarEvents = this.serializeCalendarEvents();
        activePropertyForm.get('calendarEvents')?.setValue(currentCalendarEvents);
        
        // Guardar documentos actuales (los documentos se guardan directamente en el FormControl)
        const currentDocuments = activePropertyForm.get('documents')?.value || [];
        activePropertyForm.get('documents')?.setValue(currentDocuments);
      }
    
    this.propertiesArray.controls.forEach(propertyForm => {
      // 1. Extraer los datos financieros dinámicos a través del Mapper para compatibilidad Legacy
      const financialData = propertyForm.get('financialSections')?.value || [];
      const legacyFinancials = this.mapFinancialSectionsToLegacyData(financialData);

      // Derivar URLs legacy de documentos desde el array de documents de la propiedad.
      // Si el documento fue borrado en la UI, debe quedar como null (no persistir el valor anterior).
      const propertyDocs = propertyForm.get('documents')?.value || [];
      const derivedPropertyRegistry = this.findDocUrlByName(propertyDocs, ['nota', 'registry'], 'inmueble', 'propertyRegistry');
      const derivedLoanSubscription = this.findDocUrlByName(propertyDocs, ['acuerdo', 'loan'], 'proyecto', 'loanSubscriptionAgreement');
      const derivedAgentMandate = this.findDocUrlByName(propertyDocs, ['mandat', 'agent'], 'proyecto', 'agentMandateContract');

      // Crear una estructura simplificada compatible con Firestore
      const propertyData: any = {
        id: propertyForm.get('id')?.value,
        name: propertyForm.get('name')?.value || propertyForm.get('nombre')?.value,
        
        // Características del Inmueble (campos básicos)
        floor: propertyForm.get('floor')?.value,
        rooms: propertyForm.get('rooms')?.value,
        bathrooms: propertyForm.get('bathrooms')?.value,
        squareMeters: propertyForm.get('squareMeters')?.value,
        exterior: propertyForm.get('exterior')?.value,
        elevator: propertyForm.get('elevator')?.value,
        penthouse: propertyForm.get('penthouse')?.value,
        duplex: propertyForm.get('duplex')?.value,
        building: propertyForm.get('building')?.value,
        pool: propertyForm.get('pool')?.value,
        nobleFacade: propertyForm.get('nobleFacade')?.value,

        // Estado del Proyecto
        status: propertyForm.get('status')?.value || propertyForm.get('estado')?.value,

        // Fechas Clave (como campos simples)
        launchDate: propertyForm.get('launchDate')?.value,
        purchaseDate: propertyForm.get('purchaseDate')?.value,
        renovationStartDate: propertyForm.get('renovationStartDate')?.value,
        estimatedDuration: propertyForm.get('estimatedDuration')?.value,
        actualDuration: propertyForm.get('actualDuration')?.value,
        estimatedROI: propertyForm.get('estimatedROI')?.value,
        actualROI: propertyForm.get('actualROI')?.value,
        estimatedIRR: propertyForm.get('estimatedIRR')?.value,
        actualIRR: propertyForm.get('actualIRR')?.value,

        // Inyección de Financial Adapter (Mapeo Bidireccional Compatibilidad Legacy Frontend)
        ...legacyFinancials,

        // Documentos Adicionales (derivados del array `documents` para que un borrado en la UI se propague)
        propertyRegistry: derivedPropertyRegistry,
        workReport1: propertyForm.get('workReport1')?.value,
        workReport2: propertyForm.get('workReport2')?.value,
        workReport3: propertyForm.get('workReport3')?.value,
        finalWorkReport: propertyForm.get('finalWorkReport')?.value,
        loanSubscriptionAgreement: derivedLoanSubscription,
        agentMandateContract: derivedAgentMandate,

        // Galería de Imágenes (como array simple, filtrar valores nulos/vacíos)
        gallery: this.normalizeGalleryArray((propertyForm.get('gallery') as FormArray)?.value || []),

        // Atributos específicos (normalizados sin acentos ni ñ)
        attributes: this.normalizeAttributes(propertyForm.get('attributes')?.value || propertyForm.get('atributos')?.value || '{}'),

        // Secciones financieras (como array de objetos) - obtener desde el FormControl de cada propiedad
        financialSections: propertyForm.get('financialSections')?.value || [],

        // Eventos de calendario — serializar Date objects a ISO strings antes de guardar en Firestore
        calendarEvents: (propertyForm.get('calendarEvents')?.value || []).map((event: any) => ({
          ...event,
          startDate: event.startDate instanceof Date ? event.startDate.toISOString() : (event.startDate || null),
          endDate: event.endDate instanceof Date ? event.endDate.toISOString() : (event.endDate || null),
          createdAt: event.createdAt instanceof Date ? event.createdAt.toISOString() : (event.createdAt || null),
          updatedAt: event.updatedAt instanceof Date ? event.updatedAt.toISOString() : (event.updatedAt || null),
        })),

        // Documentos (como array de objetos) - obtener desde el FormControl de cada propiedad
        documents: propertyForm.get('documents')?.value || [],

        // Descripción
        description: propertyForm.get('description')?.value,

        // Ubicación y dirección (solo este objeto anidado se mantiene)
        location: {
          country: propertyForm.get('country')?.value || null,
          stateRegion: propertyForm.get('stateRegion')?.value || null,
          city: propertyForm.get('city')?.value || null,
          neighborhood: propertyForm.get('neighborhood')?.value || null,
          postalCode: propertyForm.get('postalCode')?.value || null,
          street: propertyForm.get('street')?.value || null,
          streetNumber: propertyForm.get('streetNumber')?.value || null,
          googleMapsIframe: propertyForm.get('googleMapsIframe')?.value || null
        }
      };

      properties.push(propertyData);
    });

    return properties;
  }

  // --- RECONCILIACIÓN Y MAPEADORES BIDIRECCIONALES (ADAPTERS) ---

  /**
   * Transforma los atributos del componente financiero reactivo (array de sections) 
   * en objetos planos de base de datos. Completa compatibilidad hacia atrás.
   */
  private mapFinancialSectionsToLegacyData(sections: any[]): Record<string, any> {
    const legacyData: Record<string, any> = {};
    if (!sections || !Array.isArray(sections)) return legacyData;

    sections.forEach(section => {
      // 1. Extraer campos directos de la sección
      if (Array.isArray(section.fields)) {
        section.fields.forEach((field: any) => {
          if (field.id && field.value !== undefined && field.value !== null) {
            legacyData[field.id] = field.value;
          }
        });
      }
      
      // 2. Extraer campos de las subsecciones
      if (Array.isArray(section.subsections)) {
        section.subsections.forEach((sub: any) => {
          if (Array.isArray(sub.fields)) {
            sub.fields.forEach((field: any) => {
              if (field.id && field.value !== undefined && field.value !== null) {
                legacyData[field.id] = field.value;
              }
            });
          }
        });
      }
    });

    return legacyData;
  }

  /**
   * Extrae los valores financieros de estructuras legacy dispares (viviendas o root)
   */
  private extractLegacyFinancials(source: any): Record<string, any> {
    if (!source) return {};
    return {
      targetTerm: source.targetTerm || source.plazoObjetivo || source.financialAnalysis?.plazoObjetivo || source.financialAnalysis?.targetTerm,
      netSaleIncome: source.netSaleIncome || source.ingresoNetoVenta || source.financialAnalysis?.ingresoNetoVenta || source.financialAnalysis?.netSaleIncome,
      grossSaleIncome: source.grossSaleIncome || source.ingresosBrutosVenta || source.financialAnalysis?.ingresosBrutosVenta || source.financialAnalysis?.grossSaleIncome,
      capitalGain: source.capitalGain || source.plusvalia || source.financialAnalysis?.plusvalia || source.financialAnalysis?.capitalGain,
      realEstateCommissionSale: source.realEstateCommissionSale || source.comisionInmobiliariaVenta || source.financialAnalysis?.comisionInmobiliariaVenta || source.financialAnalysis?.realEstateCommissionSale,
      promoterIncome: source.promoterIncome || source.ingresosPromotor || source.financialAnalysis?.ingresosPromotor || source.financialAnalysis?.promoterIncome,
      investorIncome: source.investorIncome || source.ingresosInversores || source.financialAnalysis?.ingresosInversores || source.financialAnalysis?.investorIncome,
      projectProfit: source.projectProfit || source.beneficioProyecto || source.financialAnalysis?.beneficioProyecto || source.financialAnalysis?.projectProfit,
      promoterProfit: source.promoterProfit || source.beneficioPromotora || source.financialAnalysis?.beneficioPromotora || source.financialAnalysis?.promoterProfit,
      totalInvestorProfitability: source.totalInvestorProfitability || source.rentabilidadTotalInversor || source.financialAnalysis?.rentabilidadTotalInversor || source.financialAnalysis?.totalInvestorProfitability,
      annualizedInvestorProfitability: source.annualizedInvestorProfitability || source.rentabilidadAnualizadaInversor || source.financialAnalysis?.rentabilidadAnualizadaInversor || source.financialAnalysis?.annualizedInvestorProfitability,
      
      purchasePrice: source.purchasePrice || source.precioCompra || source.investmentBreakdown?.acquisitionCosts?.precioCompra || source.investmentBreakdown?.acquisitionCosts?.purchasePrice,
      realEstateCommission: source.realEstateCommission || source.comisionInmobiliaria || source.investmentBreakdown?.acquisitionCosts?.comisionInmobiliaria || source.investmentBreakdown?.acquisitionCosts?.realEstateCommission,
      fiscalTaxes: source.fiscalTaxes || source.impuestosFiscales || source.investmentBreakdown?.acquisitionCosts?.impuestosFiscales || source.investmentBreakdown?.acquisitionCosts?.fiscalTaxes,
      notaryAgencyRegistration: source.notaryAgencyRegistration || source.notariaGestoriaRegistro || source.investmentBreakdown?.acquisitionCosts?.notariaGestoriaRegistro || source.investmentBreakdown?.acquisitionCosts?.notaryAgencyRegistration,
      
      constructionCompany: source.constructionCompany || source.constructora || source.investmentBreakdown?.constructionCosts?.constructora || source.investmentBreakdown?.constructionCosts?.constructionCompany,
      licensesLegalCosts: source.licensesLegalCosts || source.licenciasCostesLegales || source.investmentBreakdown?.constructionCosts?.licenciasCostesLegales || source.investmentBreakdown?.constructionCosts?.licensesLegalCosts,
      infographics: source.infographics || source.infografias || source.investmentBreakdown?.constructionCosts?.infografias || source.investmentBreakdown?.constructionCosts?.infographics,
      externalQuantitySurveyor: source.externalQuantitySurveyor || source.aparejadorExterno || source.investmentBreakdown?.constructionCosts?.aparejadorExterno || source.investmentBreakdown?.constructionCosts?.externalQuantitySurveyor,
      furniture: source.furniture || source.muebles || source.investmentBreakdown?.constructionCosts?.muebles || source.investmentBreakdown?.constructionCosts?.furniture,
      photographer: source.photographer || source.fotografo || source.investmentBreakdown?.constructionCosts?.fotografo || source.investmentBreakdown?.constructionCosts?.photographer,
      otherExpenses: source.otherExpenses || source.otrosGastos || source.investmentBreakdown?.constructionCosts?.otrosGastos || source.investmentBreakdown?.constructionCosts?.otherExpenses,
      unforeseenExpenses: source.unforeseenExpenses || source.gastosImprevistos || source.investmentBreakdown?.constructionCosts?.gastosImprevistos || source.investmentBreakdown?.constructionCosts?.unforeseenExpenses,
      otherAdaptationExpenses: source.otherAdaptationExpenses || source.otrosGastosAdecuacion || source.investmentBreakdown?.constructionCosts?.otrosGastosAdecuacion || source.investmentBreakdown?.constructionCosts?.otherAdaptationExpenses,
      
      developmentExecution: source.developmentExecution || source.desarrolloEjecucion || source.investmentBreakdown?.desarrolloEjecucion || source.investmentBreakdown?.developmentExecution,
      domoblockManagement: source.domoblockManagement || source.gestionDomoblock || source.investmentBreakdown?.gestionDomoblock || source.investmentBreakdown?.domoblockManagement
    };
  }

  /**
   * Restaura la reactividad del componente inyectando Legacy Financials en 
   * el array de "financialSections".
   */
  private generateDynamicSectionsFromLegacyData(legacySource: any): any[] {
    // Extraer base
    const legacyValues = this.extractLegacyFinancials(legacySource);

    // Aprovechar el servicio si es posible para instanciar (o emularlo crudo)
    let defaultArray = [];
    if (this.financialSectionService) {
      this.financialSectionService.resetToDefaultSections();
      defaultArray = this.financialSectionService.getSectionsSnapshot();
    } else {
      return []; // fallback en caso extremo
    }

    // Inyectar en los fields de las sections y subsections por "id"
    defaultArray.forEach((section: any) => {
      if (Array.isArray(section.fields)) {
        section.fields.forEach((field: any) => {
          if (field.id && legacyValues[field.id] !== undefined && legacyValues[field.id] !== null) {
            field.value = legacyValues[field.id];
          }
        });
      }
      if (Array.isArray(section.subsections)) {
        section.subsections.forEach((sub: any) => {
          if (Array.isArray(sub.fields)) {
            sub.fields.forEach((field: any) => {
              if (field.id && legacyValues[field.id] !== undefined && legacyValues[field.id] !== null) {
                field.value = legacyValues[field.id];
              }
            });
          }
        });
      }
    });
    
    return defaultArray;
  }

  /**
   * Normaliza el array de galería para Firestore (solo strings válidos)
   */
  private normalizeGalleryArray(galleryArray: any): string[] {
    // Si no es un array, retornar array vacío
    if (!Array.isArray(galleryArray)) {
      return [];
    }
    
    // Filtrar y limpiar el array - solo strings válidos
    const normalized: string[] = [];
    
    for (const item of galleryArray) {
      // Ignorar null, undefined
      if (item == null) continue;
      
      let imageUrl: string | null = null;
      
      // Si es un objeto con propiedad image
      if (typeof item === 'object' && !Array.isArray(item)) {
        if (item.image && typeof item.image === 'string') {
          imageUrl = item.image.trim();
        } else if (item.value && typeof item.value === 'string') {
          imageUrl = item.value.trim();
        }
      } 
      // Si es un string directamente
      else if (typeof item === 'string') {
        imageUrl = item.trim();
      }
      // Si es un FormControl, obtener su value
      else if (item && typeof item === 'object' && 'value' in item && typeof item.value === 'string') {
        imageUrl = item.value.trim();
      }
      
      // Solo agregar si es un string válido y no vacío
      if (imageUrl && imageUrl.length > 0) {
        normalized.push(imageUrl);
      }
    }
    
    return normalized;
  }

  /**
   * Serializa las secciones financieras del servicio a JSON string
   */
  private serializeFinancialSections(): any[] {
    try {
      const sections = this.financialSectionService.getSectionsSnapshot();
      if (!sections || sections.length === 0) {
        return [];
      }
      // Convertir las secciones a un objeto serializable (remover funciones, Date objects, etc.)
      const serializableSections = sections.map(section => ({
        id: section.id,
        title: section.title,
        type: section.type,
        color: section.color,
        order: section.order,
        isCollapsed: section.isCollapsed,
        fields: section.fields.map(field => ({
          id: field.id,
          label: field.label,
          type: field.type,
          value: field.value,
          required: field.required,
          placeholder: field.placeholder,
          labelPercentage: field.labelPercentage
        })),
        subsections: (section.subsections || []).map(subsection => ({
          id: subsection.id,
          title: subsection.title,
          isFixed: subsection.isFixed,
          fields: subsection.fields.map(field => ({
            id: field.id,
            label: field.label,
            type: field.type,
            value: field.value,
            required: field.required,
            placeholder: field.placeholder,
            labelPercentage: field.labelPercentage
          }))
        }))
      }));
      return serializableSections;
    } catch (error) {
      console.error('Error serializando secciones financieras:', error);
      return [];
    }
  }

  /**
   * Serializa los eventos de calendario del servicio a un array serializable
   */
  private serializeCalendarEvents(): any[] {
    try {
      // Obtener el componente de calendario desde el DOM o usar ViewChild
      // Por ahora, vamos a obtener los eventos desde el FormControl de la propiedad activa
      const activePropertyForm = this.activeProperty;
      if (activePropertyForm) {
        const calendarEvents = activePropertyForm.get('calendarEvents')?.value || [];
        // Convertir los eventos a un objeto serializable (convertir Date objects a strings ISO)
        const serializableEvents = calendarEvents.map((event: any) => ({
          id: event.id || this.generateEventId(),
          title: event.title,
          description: event.description,
          startDate: event.startDate instanceof Date ? event.startDate.toISOString() : event.startDate,
          endDate: event.endDate instanceof Date ? event.endDate.toISOString() : event.endDate,
          icon: event.icon || '📅',
          status: event.status || 'pending',
          type: event.type || 'custom',
          color: event.color || '#6c757d',
          isEditable: event.isEditable !== undefined ? event.isEditable : true,
          order: event.order !== undefined ? event.order : 0,
          createdAt: event.createdAt instanceof Date ? event.createdAt.toISOString() : (event.createdAt || new Date().toISOString()),
          updatedAt: event.updatedAt instanceof Date ? event.updatedAt.toISOString() : (event.updatedAt || new Date().toISOString())
        }));
        return serializableEvents;
      }
      return [];
    } catch (error) {
      console.error('Error serializando eventos de calendario:', error);
      return [];
    }
  }

  /**
   * Genera un ID único para eventos de calendario
   */
  private generateEventId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  // Método para obtener todas las viviendas del formulario como array (compatibilidad)

  // Método para ordenar atributos (formato antiguo)
  ordenarAtributos() {
    try {
      const atributosOrdenados = this.getAtributosJsonFromString(this.attributes?.value || '{}');
      
      const atributosString = `{${Object.entries(atributosOrdenados)
        .map(
          ([key, value]) =>
            `"${key}": ${typeof value === 'string' ? `"${value}"` : value}`
        )
        .join(', ')}}`;
      
      this.attributes?.setValue(atributosString);
    } catch (error) {
      console.error('Error en ordenarAtributos:', error);
    }
  }

  private buildInvestmentPayload(preparedProperties?: any[]): any {
    const properties = preparedProperties ?? this.getAllPropertiesFromForm();

    // Derivar URLs legacy de documentos del root desde el array `documents` de la propiedad principal
    // para que un borrado en la pestaña Documentación se propague también al draft/payload.
    const mainIdx = this.getSafeMainPropertyIndex(properties?.length || 0);
    const mainDocs = Array.isArray(properties?.[mainIdx]?.documents) ? properties[mainIdx].documents : [];
    const wpUrlDerived = this.findDocUrlByName(mainDocs, ['whitepaper', 'white paper'], undefined, 'urlWhitepapperPdf');
    const dosierUrlDerived = this.findDocUrlByName(mainDocs, ['dosier', 'dossier'], undefined, 'urlDosierPdf');
    const tokenUrlDerived = this.findDocUrlByName(mainDocs, ['token', 'info'], undefined, 'tokenInfoPdfUrl');

    const item: any = {
      // Campos principales de la estructura antigua
      id: this.id,
      title: this.title?.getRawValue(),
      company: this.developer?.getRawValue() || this.formNewNft.get('company')?.value,
      country: this.country?.getRawValue(),
      stateCCAAProvince: this.stateRegion?.getRawValue(),
      location: this.city?.getRawValue(),
      neighborhood: this.neighborhood?.getRawValue(),
      street: this.street?.getRawValue(),
      cp: this.postalCode?.getRawValue(),
      iframeGoogleMaps: this.googleMapsIframe?.getRawValue() || this.formNewNft.get('iframeGoogleMaps')?.value,
      description: this.description?.getRawValue(),
      activationDate: this.activationDate?.getRawValue() ? new Date(this.activationDate.getRawValue()) : null,
      estimatedDeliveryTime: this.estimatedDeliveryPeriod?.getRawValue() || this.formNewNft.get('estimatedDeliveryTime')?.value,
      annualReturn: this.annualProfitability?.getRawValue() || this.formNewNft.get('annualReturn')?.value,
      amountSold: this.isEditMode ? this.projectToEdit.amountSold || 0 : 0,
      amountToSell: this.amountToSell?.getRawValue(),
      priceToken: (this.tokenPrice?.getRawValue() || this.formNewNft.get('priceToken')?.value || 0) * 100, // Stored in Cents
      minimumInvestment: this.minimumInvestment?.getRawValue(),
      stableCoinAddress: this.stableCoinAddress?.getRawValue(),
      beneficiaryAddress: this.beneficiaryAddress?.getRawValue(),
      aggregatorStableCoinDolar: this.aggregatorStableCoinDollar?.getRawValue(),
      hide: false,
      blockchain: this.toBlockchain?.getRawValue() || this.formNewNft.get('blockchain')?.value || false,
      onlyInversors: this.onlyInvestors?.getRawValue() || this.formNewNft.get('onlyInversors')?.value || false,
      managingInvestments: this.managingInvestments?.getRawValue() || false,
      nameTokens: this.tokenName?.getRawValue() || this.formNewNft.get('nameTokens')?.value,
      symbolTokens: this.tokenSymbol?.getRawValue() || this.formNewNft.get('symbolTokens')?.value,
      propertyType: this.propertyType?.getRawValue() || 'House Flipping',
      projectWallet: this.formNewNft.get('projectWallet')?.value || (this.isEditMode ? this.projectToEdit.projectWallet : null),
      sellerAddress: this.formNewNft.get('sellerAddress')?.value || (this.isEditMode ? this.projectToEdit.sellerAddress : null),
      tokensAddress: this.formNewNft.get('tokensAddress')?.value || (this.isEditMode ? this.projectToEdit.tokensAddress : null),
      dividendsAddress: this.formNewNft.get('dividendsAddress')?.value || (this.isEditMode ? this.projectToEdit.dividendsAddress : null),
      NftID: this.formNewNft.get('NftID')?.value || (this.isEditMode ? this.projectToEdit.NftID : null),
      endOfSale: this.isEditMode ? this.projectToEdit.endOfSale || 0 : 0,
      numberInvestors: this.isEditMode ? this.projectToEdit.numberInvestors || 0 : 0,
      hoursToSell: this.isEditMode ? this.projectToEdit.hoursToSell || 0 : 0,
      reserves: this.formNewNft.get('reserves')?.value || 0,
      lastStatusUpdate: this.formNewNft.get('lastStatusUpdate')?.value || new Date().toISOString(),
      proyectStatus: this.formNewNft.get('proyectStatus')?.value || (this.isEditMode ? this.projectToEdit.proyectStatus || 'En estudio' : 'En estudio'),
      
      // Campos de documentos (estructura antigua)
      images: this.formNewNft.get('images')?.value || [],
      infoProyecto: this.projectInfo?.getRawValue() || this.formNewNft.get('infoProyecto')?.value,
      mainImage: this.getResolvedCoverImage(),
      urlDosierPdf: dosierUrlDerived,
      urlInfoTokenPdf: tokenUrlDerived,
      urlWhitepapperPdf: wpUrlDerived,

      // NUEVOS CAMPOS: Array de propiedades (estructura nueva)
      properties: properties,

      // Campos adicionales para compatibilidad
      ...(this.onlyInvestors?.getRawValue() ? { percentageToPrivateSale: this.percentageToPrivateSale?.getRawValue() } : {})
    };

    const cleanedItem = this.cleanUndefinedFields(item);
    return this.makeFirestoreCompatible(cleanedItem);
  }

  saveDraft(): void {
    try {
      const draftPayload = this.buildInvestmentPayload();
      const draftData = {
        ...draftPayload,
        draftMetadata: {
          savedAt: new Date().toISOString()
        }
      };
      this.persistDraftData(draftData);
      this.draftAvailable = true;

      Swal.fire({
        icon: 'success',
        title: 'Borrador guardado',
        text: 'Tu progreso se guardó en este dispositivo.',
        timer: 2000,
        showConfirmButton: false
      });
    } catch (error) {
      console.error('Error saving draft:', error);
      Swal.fire({
        icon: 'error',
        title: 'No se pudo guardar',
        text: error instanceof Error ? error.message : 'Revisa los datos e intenta nuevamente.'
      });
    }
  }

  async deleteDraft(): Promise<void> {
    const storage = this.getLocalStorage();
    if (!storage || !storage.getItem(this.DRAFT_STORAGE_KEY)) {
      this.clearDraftStorage();
      Swal.fire({
        icon: 'info',
        title: 'Sin borradores',
        text: 'No hay borradores guardados actualmente.',
        timer: 2000,
        showConfirmButton: false
      });
      return;
    }

    const confirmation = await Swal.fire({
      icon: 'warning',
      title: '¿Eliminar borrador?',
      text: 'Esta acción eliminará el progreso guardado en este dispositivo.',
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar'
    });

    if (!confirmation.isConfirmed) {
      return;
    }

    this.clearDraftStorage();

    Swal.fire({
      icon: 'success',
      title: 'Borrador eliminado',
      timer: 1800,
      showConfirmButton: false
    });
  }

  async newNft() {
    // Mostrar modal de opciones antes de crear/actualizar (si cancelan, no seguimos)
    const modalResult = await this.showCreationOptionsModal();
    if (!modalResult.confirmed) {
      return;
    }
    // Aplicar opciones seleccionadas al formulario
    this.toBlockchain?.patchValue(modalResult.toBlockchain);
    this.managingInvestments?.patchValue(modalResult.managingInvestments);
    this.onlyInvestors?.patchValue(modalResult.onlyInvestors);
    if (modalResult.onlyInvestors) {
      this.percentageToPrivateSale?.setValidators([Validators.required, Validators.min(0), Validators.max(100)]);
      this.percentageToPrivateSale?.patchValue(modalResult.percentageToPrivateSale);
    } else {
      this.percentageToPrivateSale?.clearValidators();
    }
    this.percentageToPrivateSale?.updateValueAndValidity();
    
    // Debug: Mostrar información de validación en consola
    this.debugFormValidation();
    
    // Validar formulario principal tras aplicar opciones
    if (this.formNewNft.invalid) { 
      this.formNewNft.markAllAsTouched();
      const invalidFields = this.getInvalidFields(this.formNewNft);
      await Swal.fire({
        icon: 'warning',
        title: 'Campos obligatorios',
        html: `Los siguientes campos son obligatorios:<br><br>${invalidFields.join('<br>')}`
      });
      return; 
    }

    // Ya no validamos las propiedades individuales - solo los campos generales del proyecto
    // Las propiedades son opcionales y no tienen campos obligatorios

    // Verificar si el usuario es administrador
    const isAdmin = this.authService.admin.getValue();
    
    if (!isAdmin) {
      // Verificar en la colección de administradores como respaldo
      const user = this.authService.userAuth.getValue();
      if (user) {
        this.afs.collection('administrators').doc(user.uid).get()
          .pipe()
          .subscribe(doc => {
          if (doc.exists) {
            const adminData = doc.data() as any;
            if (adminData && (adminData.rol === 'admin' || adminData.rol === 'superadmin')) {
              // Intentar refrescar los claims
              this.authService.checkAdmin();
            }
          }
        });
      }
      
      await Swal.fire({
        icon: 'error',
        title: 'Acceso denegado',
        text: 'Solo los administradores pueden crear proyectos. Contacta al administrador del sistema.'
      });
      return;
    }

    // Bloquear UI mientras se guarda
    this.loadingFlag = true;
    this.formNewNft.disable({ emitEvent: false });
    
    // También deshabilitar formularios de propiedades
    this.viviendasArray.controls.forEach(control => {
      if (control instanceof FormGroup) {
        control.disable({ emitEvent: false });
      }
    });

    // Subir imágenes y documentos antes de guardar el proyecto
    await this.uploadPendingFiles();

    // Procesar todas las propiedades
    const properties = this.getAllPropertiesFromForm();

    // Si el proyecto está en blockchain, solo actualizar campos seguros
    if (this.isEditMode && this.isProjectInBlockchain()) {
      const safeUpdates: any = {
        id: this.id,
        description: this.description?.getRawValue(),
        urlWhitepapperPdf: this.formNewNft.get('urlWhitepapperPdf')?.value ?? this.whitePaper,
        urlDosierPdf: this.formNewNft.get('urlDosierPdf')?.value ?? this.dosier,
        urlInfoTokenPdf: this.formNewNft.get('tokenInfoPdfUrl')?.value ?? this.infoToken,
        tokenInfoPdfUrl: this.formNewNft.get('tokenInfoPdfUrl')?.value ?? this.infoToken,
        // Rentabilidad y duración: campos legacy del root que alimentan las cards de oportunidades.
        annualReturn: this.annualProfitability?.getRawValue() ?? this.formNewNft.get('annualReturn')?.value,
        estimatedDeliveryTime: this.estimatedDeliveryPeriod?.getRawValue() ?? this.formNewNft.get('estimatedDeliveryTime')?.value,
        properties: properties,
        mainPropertyIndex: this.mainPropertyIndex,
        mainPropertyCoverIndex: this.mainPropertyCoverIndex,
        mainImageUrl: this.getResolvedCoverImage(),
        projectInfo: this.projectInfo?.getRawValue(),
        proyectStatus: this.formNewNft.get('proyectStatus')?.value || (this.isEditMode ? this.projectToEdit.proyectStatus || 'En estudio' : 'En estudio')
      };

      // HOISTING PARA COMPATIBILIDAD CON VISTAS LEGACY (App Set Data)
      if (properties && properties.length > 0) {
        const safeIndex = this.getSafeMainPropertyIndex(properties.length);
        const mainProp = properties[safeIndex];
        // 1. Hoist de campos financieros legacy al root
        const financialKeys = [
          'photographer', 'otherExpenses', 'unforeseenExpenses', 'otherAdaptationExpenses',
          'developmentExecution', 'domoblockManagement'
        ];
        financialKeys.forEach(key => {
          if (mainProp[key] !== undefined && mainProp[key] !== null) {
            safeUpdates[key] = mainProp[key];
          }
        });
        // 2. Sincronizar URLs legacy con el array de documentos (un borrado en la UI debe propagarse).
        const mainDocs = Array.isArray(mainProp.documents) ? mainProp.documents : [];
        const wpUrl = this.findDocUrlByName(mainDocs, ['whitepaper', 'white paper'], undefined, 'urlWhitepapperPdf');
        const dosierUrl = this.findDocUrlByName(mainDocs, ['dosier', 'dossier'], undefined, 'urlDosierPdf');
        const tokenUrl = this.findDocUrlByName(mainDocs, ['token', 'info'], undefined, 'tokenInfoPdfUrl');

        safeUpdates.urlWhitepapperPdf = wpUrl;
        safeUpdates.urlDosierPdf = dosierUrl;
        safeUpdates.urlInfoTokenPdf = tokenUrl;
        safeUpdates.tokenInfoPdfUrl = tokenUrl;
      }

      // Actualizar solo los campos seguros vía BFF usando toPromise para mantener compatibilidad
      const cleanedSafeUpdates = this.cleanUndefinedFields(safeUpdates);
      this.projectsV1Service.updateProject(this.id, cleanedSafeUpdates).toPromise()
        .then(async () => {
          // Actualizar investments-reader con los datos actualizados
          const updatedItem = await this.afs.collection('investments').doc(this.id).get().toPromise();
          if (updatedItem?.exists) {
            await this.createOrUpdateInvestmentReader(updatedItem.data());
          }
          
          Swal.fire({
            icon: 'success',
            text: `Proyecto actualizado (solo campos seguros)`
          }).then(() => {
            this.close.emit(true);
          });
        })
        .catch((err: any) => { 
          // Manejar error específicamente si proviene del backend (violación de DDD/BFF)
          const errorMsg = err?.error?.message || err?.message || 'Algo ha ido mal!';
          Swal.fire({
            icon: 'error',
            title: 'No Autorizado',
            text: errorMsg
          });
        })
        .finally(() => {
          this.loadingFlag = false;
          this.formNewNft.enable({ emitEvent: false });
          
          // Rehabilitar formularios de propiedades
          this.viviendasArray.controls.forEach(control => {
            if (control instanceof FormGroup) {
              control.enable({ emitEvent: false });
            }
          });
        });
      return;
    }

    // Para proyectos nuevos o no desplegados, usar la lógica completa
    // MANTENER ESTRUCTURA ANTIGUA COMO BASE PRINCIPAL
    const item: any = {
      // Campos principales de la estructura antigua
      id: this.id,
      title: this.title?.getRawValue(),
      company: this.developer?.getRawValue() || this.formNewNft.get('company')?.value,
      country: this.country?.getRawValue(),
      stateCCAAProvince: this.stateRegion?.getRawValue(),
      location: this.city?.getRawValue(),
      neighborhood: this.neighborhood?.getRawValue(),
      street: this.street?.getRawValue(),
      cp: this.postalCode?.getRawValue(),
      iframeGoogleMaps: this.googleMapsIframe?.getRawValue() || this.formNewNft.get('iframeGoogleMaps')?.value,
      description: this.description?.getRawValue(),
      activationDate: this.activationDate?.getRawValue() ? new Date(this.activationDate.getRawValue()) : null,
      estimatedDeliveryTime: this.estimatedDeliveryPeriod?.getRawValue() || this.formNewNft.get('estimatedDeliveryTime')?.value,
      annualReturn: this.annualProfitability?.getRawValue() || this.formNewNft.get('annualReturn')?.value,
      amountSold: this.isEditMode ? this.projectToEdit.amountSold || 0 : 0,
      amountToSell: this.amountToSell?.getRawValue(),
      priceToken: (this.tokenPrice?.getRawValue() || this.formNewNft.get('priceToken')?.value || 0) * 100, // Stored in Cents
      minimumInvestment: this.minimumInvestment?.getRawValue(),
      stableCoinAddress: this.stableCoinAddress?.getRawValue(),
      beneficiaryAddress: this.beneficiaryAddress?.getRawValue(),
      aggregatorStableCoinDolar: this.aggregatorStableCoinDollar?.getRawValue(),
      hide: false,
      blockchain: this.toBlockchain?.getRawValue() || this.formNewNft.get('blockchain')?.value || false,
      onlyInversors: this.onlyInvestors?.getRawValue() || this.formNewNft.get('onlyInversors')?.value || false,
      managingInvestments: this.managingInvestments?.getRawValue() || false,
      nameTokens: this.tokenName?.getRawValue() || this.formNewNft.get('nameTokens')?.value,
      symbolTokens: this.tokenSymbol?.getRawValue() || this.formNewNft.get('symbolTokens')?.value,
      propertyType: this.propertyType?.getRawValue() || 'House Flipping',
      projectWallet: this.formNewNft.get('projectWallet')?.value || (this.isEditMode ? this.projectToEdit.projectWallet : null),
      sellerAddress: this.formNewNft.get('sellerAddress')?.value || (this.isEditMode ? this.projectToEdit.sellerAddress : null),
      tokensAddress: this.formNewNft.get('tokensAddress')?.value || (this.isEditMode ? this.projectToEdit.tokensAddress : null),
      dividendsAddress: this.formNewNft.get('dividendsAddress')?.value || (this.isEditMode ? this.projectToEdit.dividendsAddress : null),
      NftID: this.formNewNft.get('NftID')?.value || (this.isEditMode ? this.projectToEdit.NftID : null),
      endOfSale: this.isEditMode ? this.projectToEdit.endOfSale || 0 : 0,
      numberInvestors: this.isEditMode ? this.projectToEdit.numberInvestors || 0 : 0,
      hoursToSell: this.isEditMode ? this.projectToEdit.hoursToSell || 0 : 0,
      reserves: this.formNewNft.get('reserves')?.value || 0,
      lastStatusUpdate: this.formNewNft.get('lastStatusUpdate')?.value || new Date().toISOString(),
      proyectStatus: this.formNewNft.get('proyectStatus')?.value || (this.isEditMode ? this.projectToEdit.proyectStatus || 'En estudio' : 'En estudio'),
      
      // Campos de documentos (estructura antigua y nueva)
      images: this.formNewNft.get('images')?.value || [],
      infoProyecto: this.projectInfo?.getRawValue() || this.formNewNft.get('infoProyecto')?.value,
      mainImage: this.getResolvedCoverImage(),
      mainImageUrl: this.getResolvedCoverImage(),
      urlDosierPdf: this.formNewNft.get('urlDosierPdf')?.value ?? this.dosier,
      urlInfoTokenPdf: this.formNewNft.get('tokenInfoPdfUrl')?.value ?? this.infoToken,
      tokenInfoPdfUrl: this.formNewNft.get('tokenInfoPdfUrl')?.value ?? this.infoToken,
      urlWhitepapperPdf: this.formNewNft.get('urlWhitepapperPdf')?.value ?? this.whitePaper,

      // NOTA: Los atributos ahora se guardan en cada propiedad individual, no a nivel raíz
      // attributes: this.getLegacyAttributesFromProperties(properties), // ELIMINADO
      
      // NUEVOS CAMPOS: Array de propiedades (estructura nueva)
      properties: properties,
      mainPropertyIndex: this.mainPropertyIndex,
      mainPropertyCoverIndex: this.mainPropertyCoverIndex,
      
      // Campos adicionales para compatibilidad
      ...(this.onlyInvestors?.getRawValue() ? { percentageToPrivateSale: this.percentageToPrivateSale?.getRawValue() } : {})
    };

    // HOISTING PARA COMPATIBILIDAD CON VISTAS LEGACY (App Set Data)
    if (properties && properties.length > 0) {
      const safeIndex = this.getSafeMainPropertyIndex(properties.length);
      const mainProp = properties[safeIndex];
      
      // 1. Hoist de campos financieros legacy al root
      const financialKeys = [
        'photographer', 'otherExpenses', 'unforeseenExpenses', 'otherAdaptationExpenses',
        'developmentExecution', 'domoblockManagement'
      ];
      financialKeys.forEach(key => {
        if (mainProp[key] !== undefined && mainProp[key] !== null) {
          item[key] = mainProp[key];
        }
      });

      // 2. Sincronizar URLs legacy con el array de documentos: si el doc fue borrado en la UI,
      // su URL legacy debe quedar nula. Si está, prevalece la del array.
      const mainDocs = Array.isArray(mainProp.documents) ? mainProp.documents : [];
      const wpUrl = this.findDocUrlByName(mainDocs, ['whitepaper', 'white paper'], undefined, 'urlWhitepapperPdf');
      const dosierUrl = this.findDocUrlByName(mainDocs, ['dosier', 'dossier'], undefined, 'urlDosierPdf');
      const tokenUrl = this.findDocUrlByName(mainDocs, ['token', 'info'], undefined, 'tokenInfoPdfUrl');

      item.urlWhitepapperPdf = wpUrl;
      item.urlDosierPdf = dosierUrl;
      item.urlInfoTokenPdf = tokenUrl;
      item.tokenInfoPdfUrl = tokenUrl;
      this.whitePaper = wpUrl || '';
      this.dosier = dosierUrl || '';
      this.infoToken = tokenUrl || '';
    }

    // Limpiar campos undefined para evitar errores de Firestore
    const cleanedItem = this.cleanUndefinedFields(item);
    
    // Simplificar aún más la estructura para evitar errores de Firestore
    const firestoreCompatibleItem = this.makeFirestoreCompatible(cleanedItem);
    
    this.addInvestment(firestoreCompatibleItem);
  }

  private async showCreationOptionsModal(): Promise<{ confirmed: boolean; toBlockchain: boolean; managingInvestments: boolean; onlyInvestors: boolean; percentageToPrivateSale?: number; }> {
    return new Promise(async (resolve) => {
      const initialToBlockchain = !!this.toBlockchain?.getRawValue();
      const initialManaging = !!this.managingInvestments?.getRawValue();
      const initialOnlyInv = !!this.onlyInvestors?.getRawValue();
      const rawPct = this.percentageToPrivateSale?.getRawValue();
      const initialPct = rawPct !== null && rawPct !== undefined ? Number(rawPct) : '';

      const { value: formValues } = await Swal.fire({
        title: 'Opciones de creación',
        html:
          '<div style="text-align:left" data-testid="project-creation-options-modal-content">' +
          '<div class="form-check mb-2">' +
          `<input id="swal-toBlockchain" data-testid="project-creation-blockchain-checkbox" class="form-check-input" type="checkbox" ${initialToBlockchain ? 'checked' : ''}>` +
          '<label class="form-check-label" for="swal-toBlockchain">Desplegar en la Blockchain</label>' +
          '</div>' +
          '<div class="form-check mb-2">' +
          `<input id="swal-managingInvestments" data-testid="project-creation-managing-investments-checkbox" class="form-check-input" type="checkbox" ${initialManaging && !initialOnlyInv ? 'checked' : ''}>` +
          '<label class="form-check-label" for="swal-managingInvestments">Gestionando reinversiones</label>' +
          '</div>' +
          '<div class="form-check mb-2">' +
          `<input id="swal-onlyInvestors" data-testid="project-creation-only-investors-checkbox" class="form-check-input" type="checkbox" ${initialOnlyInv ? 'checked' : ''}>` +
          '<label class="form-check-label" for="swal-onlyInvestors">Solo inversores</label>' +
          '</div>' +
          '<div class="mb-2" id="swal-privateSaleContainer" data-testid="project-creation-private-sale-container" style="display:none">' +
          '<label for="swal-percentagePrivate" class="form-label">Porcentaje de pre-venta (%)</label>' +
          `<input id="swal-percentagePrivate" data-testid="project-creation-private-sale-percent-input" type="number" min="0" max="100" class="form-control" value="${initialPct}" placeholder="Ej: 75">` +
          '</div>' +
          '</div>',
        focusConfirm: false,
        showCancelButton: true,
        confirmButtonText: 'Continuar',
        cancelButtonText: 'Cancelar',
        didOpen: () => {
          const popup = Swal.getPopup();
          popup?.querySelector('.swal2-confirm')?.setAttribute('data-testid', 'project-creation-options-confirm-btn');
          popup?.querySelector('.swal2-cancel')?.setAttribute('data-testid', 'project-creation-options-cancel-btn');

          // Use standard document.getElementById since Swal renders into the body
          const chkManaging = document.getElementById('swal-managingInvestments') as HTMLInputElement;
          const chkOnly = document.getElementById('swal-onlyInvestors') as HTMLInputElement;
          const pctContainer = document.getElementById('swal-privateSaleContainer') as HTMLDivElement;

          console.log('🔎 [DEBUG] Event Listener Setup - Elements:', { chkManaging, chkOnly, pctContainer });

          const syncUI = () => {
            console.log('🔄 [DEBUG] syncUI triggered. Only:', chkOnly?.checked, 'Managing:', chkManaging?.checked);
            if (chkOnly && chkOnly.checked) {
              if (chkManaging) chkManaging.checked = false;
              if (pctContainer) pctContainer.style.display = 'block';
            } else {
              if (pctContainer) pctContainer.style.display = 'none';
            }
          };

          if (chkManaging) {
             chkManaging.onchange = () => {
                 console.log('CLICK Managing');
                 if (chkManaging.checked && chkOnly) chkOnly.checked = false;
                 syncUI();
             };
          }
          if (chkOnly) {
             chkOnly.onchange = () => {
                 console.log('CLICK Only Investors');
                 if (chkOnly.checked && chkManaging) chkManaging.checked = false;
                 syncUI();
             };
          }

          // Initial sync
          syncUI();
        },
        preConfirm: () => {
          const toBlockchain = (document.getElementById('swal-toBlockchain') as HTMLInputElement)?.checked || false;
          const managingInvestments = (document.getElementById('swal-managingInvestments') as HTMLInputElement)?.checked || false;
          const onlyInvestors = (document.getElementById('swal-onlyInvestors') as HTMLInputElement)?.checked || false;
          let percentageToPrivateSale: number | undefined = undefined;
          if (onlyInvestors) {
            const pctStr = (document.getElementById('swal-percentagePrivate') as HTMLInputElement)?.value;
            const pct = Number(pctStr);
            if (isNaN(pct) || pct < 0 || pct > 100) {
              Swal.showValidationMessage('Introduce un porcentaje válido (0-100)');
              return false as any;
            }
            percentageToPrivateSale = pct;
          }
          return { toBlockchain, managingInvestments, onlyInvestors, percentageToPrivateSale };
        }
      });

      if (!formValues) {
        resolve({ confirmed: false, toBlockchain: false, managingInvestments: false, onlyInvestors: false });
      } else {
        resolve({ confirmed: true, ...formValues });
      }
    });
  }

  addInvestment(item: any) {
    
    this.afs.collection('investments').doc(this.id).set(item, {merge: true})
      .then(async() => {
        // Crear/actualizar el documento investments-reader automáticamente
        await this.createOrUpdateInvestmentReader(item);
        
        // Solo registrar transición para proyectos nuevos
        if (!this.isEditMode) {
          try {
            // Obtener el uid del usuario que está creando el proyecto
            const user = this.authService.userAuth.getValue();
            const userId = user?.uid || 'auto-system';
            
            if (user) {
              user.getIdTokenResult().then((tokenResult: any) => {
              });
            }
            
            await this.timelineService.recordTransition(
              this.id,
              null,
              'En estudio',
              'Proyecto creado',
              userId
            );
          } catch (error: any) {
            console.error('­ƒöº [DEBUG] Error registrando transición inicial:', error);
            console.error('­ƒöº [DEBUG] Error details:', {
              message: error?.message,
              code: error?.code,
              stack: error?.stack
            });
            // No fallar si no se puede registrar la transición
          }

          await this.createProjectWallet(this.id);
        }
        
        if (this.toBlockchain?.getRawValue() === true) {
          // Validation specific for Blockchain deployment
          if (!this.beneficiaryAddress?.value) {
             const { value: address } = await Swal.fire({
               title: 'Falta dirección del beneficiario',
               text: 'Para desplegar en blockchain, es necesaria la "Wallet que recibe (beneficiary)". Introdúcela aquí:',
               input: 'text',
               inputPlaceholder: '0x...',
               showCancelButton: true,
               confirmButtonText: 'Guardar y Continuar',
               cancelButtonText: 'Cancelar',
               inputValidator: (value) => {
                 if (!value) {
                   return 'Debes introducir una dirección!';
                 }
                 if (!value.startsWith('0x') || value.length !== 42) {
                   return 'Formato de dirección inválido (debe empezar por 0x y tener 42 caracteres)';
                 }
                 return null;
               }
             });

             if (address) {
               this.beneficiaryAddress?.setValue(address);
             } else {
               this.loadingFlag = false;
               this.formNewNft.enable({ emitEvent: false });
               this.viviendasArray.controls.forEach(c => c.enable({ emitEvent: false }));
               return;
             }
          }

          const _id = this.id;
          this.addProyectToBlockchain(_id);
        } else {
          const successMessage = this.isEditMode ? 
            'Proyecto actualizado correctamente' : 
            'Proyecto subido a la BBDD (No blockchain)';
            
          Swal.fire({
            icon: 'success',
            text: successMessage
          }).then(() => {
            this.close.emit(true);
          });

          if (!this.isEditMode) {
            this.clearDraftStorage();
            this.id = Date.now().toString();
            this.resetVariables();
          }
          this.loadingFlag = false;
          this.formNewNft.enable({ emitEvent: false });
          
          // Rehabilitar formularios de propiedades
          this.viviendasArray.controls.forEach(control => {
            if (control instanceof FormGroup) {
              control.enable({ emitEvent: false });
            }
          });
        }
      })
      .catch((error) => { 
        console.error('Error en addInvestment:', error);
        
        if (!this.isEditMode) {
          this.id = Date.now().toString();
        }

        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: 'Algo ha ido mal!'
        });
        this.loadingFlag = false;
        this.formNewNft.enable({ emitEvent: false });
        
        // Rehabilitar formularios de propiedades
        this.viviendasArray.controls.forEach(control => {
          if (control instanceof FormGroup) {
            control.enable({ emitEvent: false });
          }
        });
      });
  }

  async addProyectToBlockchain(id: string) {
    console.log('🔷 [DEBUG] addProyectToBlockchain called with ID:', id);
    
    if (!this.web3) {
        console.error('❌ [DEBUG] Web3 instance is missing!');
        Swal.fire('Error', 'Web3 instance not found', 'error');
        return;
    }

    Swal.fire({
      title: 'Procesando...',
      html: 'No cierres esta pantalla!!',
      allowEscapeKey: false,
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      }
    });

    const baseFee: number = await this.web3.eth.getBlock('pending').then((block: any) => { 
      // Calculamos maxFee = baseFee actual + 30 gwei extra por seguridad 
      // (antes estaba en +100 gwei absurdos subiendo el coste final)
      return Number(block.baseFeePerGas) + 30000000000; 
    });

    console.log('🚀 [DEBUG] Preparing to mint NFT...');
    console.log('   - Amount (Wei):', this.formatToWei(this.amountToSell?.getRawValue()));
    console.log('   - ID:', id);
    console.log('   - StableCoin:', this.stableCoinAddress?.getRawValue());
    console.log('   - Beneficiary:', this.beneficiaryAddress?.getRawValue());
    console.log('   - Aggregator:', this.aggregatorStableCoinDollar?.getRawValue());
    console.log('   - Name:', this.tokenName?.getRawValue());
    console.log('   - Symbol:', this.tokenSymbol?.getRawValue());
    console.log('   - From Address:', this.ourAddress);
    
    if (!this.contractManager) {
        console.error('❌ [DEBUG] Contract Manager is UNDEFINED!');
        Swal.fire('Error', 'Contract Manager not initialized', 'error');
        return;
    }

    this.contractManager.methods.mintNft(
      this.formatToWei(this.amountToSell?.getRawValue()),
      id,
      this.stableCoinAddress?.getRawValue(),
      this.beneficiaryAddress?.getRawValue(),
      this.aggregatorStableCoinDollar?.getRawValue(),
      this.tokenName?.getRawValue(),
      this.tokenSymbol?.getRawValue()
    ).send({from: this.ourAddress, maxFeePerGas: this.web3.utils.toHex(baseFee), maxPriorityFeePerGas: this.web3.utils.toHex(this.web3.utils.toWei('5', 'gwei'))}) 
      .then(() => {
        this.web3.eth.getBlockNumber().then((res: any) => {
          const blockNumber: number = res;

          const checkEvents = (retries: number) => {
            this.contractManager.getPastEvents('newMint', {
              fromBlock: blockNumber - 8
            }, (err: any, events: any[]) => { 
              if (err || !events || events.length === 0) {
                if (retries > 0) {
                  console.warn(`[Blockchain] Evento newMint no encontrado. Reintentando... (${retries} intentos restantes)`);
                  setTimeout(() => checkEvents(retries - 1), 3000); // Esperar 3s
                } else {
                  Swal.fire({
                    icon: 'warning',
                    title: 'Blockchain saturada',
                    html: 'La transacción se ejecutó pero la red va extremadamente lenta.<br><br>Se ha guardado el proyecto pero las direcciones (FT/NFT) se guardaron como `null` en la BBDD por timeout.<br>Avisa a los desarrolladores o corrígelo a mano en tu base de datos si es necesario.'
                  }).then(() => {
                    this.loadingFlag = false;
                    this.formNewNft.enable({ emitEvent: false });
                    this.close.emit(true);
                  });
                }
                return;
              }

              // Buscar el evento correcto en nuestro bloque
              const e = events.find((evt: any) => evt && evt.returnValues && this.web3.utils.sha3(id) === evt.returnValues.uri) || events[0];
  
              if (e && e.returnValues && this.web3.utils.sha3(id) === e.returnValues.uri) {
              const nftID = e.returnValues.e_NftID;
              
              // Actualizar FormControl con el NftID obtenido de blockchain
              this.formNewNft.get('NftID')?.setValue(nftID);
              this.formNewNft.get('sellerAddress')?.setValue(e.returnValues.e_seller);
              this.formNewNft.get('tokensAddress')?.setValue(e.returnValues.e_holdings);
              this.formNewNft.get('dividendsAddress')?.setValue(e.returnValues.e_dividends);
              
              this.afs.collection('investments').doc(id).set({
                sellerAddress: e.returnValues.e_seller,
                tokensAddress: e.returnValues.e_holdings,
                dividendsAddress: e.returnValues.e_dividends,
                NftID: nftID
              }, {merge: true}).then(async () => {
                
                // --- INICIO DE SINCRONIZACIÓN DE REGLAS BASICAS ---
                Swal.fire({
                  title: 'Configurando Reglas del Contrato...',
                  html: 'Firma las siguientes transacciones en Metamask para inyectar el Precio y el Mínimo de Inversión.<br><br><b>No cierres esta pantalla.</b>',
                  allowEscapeKey: false,
                  allowOutsideClick: false,
                  didOpen: () => { Swal.showLoading() }
                });

                try {
                  const pendingBlock: any = await this.web3.eth.getBlock('pending');
                  const baseFee: number = Number(pendingBlock.baseFeePerGas) + 100000000000;
                  const maxPriority = this.web3.utils.toHex(this.web3.utils.toWei('50', 'gwei'));
                  const sellerStr = e.returnValues.e_seller;
                  
                  // (Nota: En apimodular se elimina la ejecución aquí de setPriceSeller y setMinTokensBuy para paridad con legacy,
                  //        abaratando costes de red y delegándolo al flujo SetDataSale posterior como ocurría en phase4).
                } catch (error) {
                  console.error("Falló la configuración inicial del contrato inteligente", error);
                  await Swal.fire('Aviso', 'El Inmueble se creó pero cancelaste o falló la configuración de inversión mínima en Polygon. Podrás configurarlo luego en "Activar Preventas".', 'warning');
                }
                // --- FIN DE SINCRONIZACIÓN ---

                // Actualizar investments-reader con los nuevos datos de blockchain
                const updatedItem = await this.afs.collection('investments').doc(id).get().toPromise();
                if (updatedItem?.exists) {
                  await this.createOrUpdateInvestmentReader(updatedItem.data());
                }
                
                this.loadingFlag = false;
                this.formNewNft.enable({ emitEvent: false });
                
                // Rehabilitar formularios de propiedades
                this.viviendasArray.controls.forEach(control => {
                  if (control instanceof FormGroup) {
                    control.enable({ emitEvent: false });
                  }
                });
                Swal.close();
                const successMessage = this.isEditMode ? 
                  'Proyecto actualizado en BBDD y Blockchain' : 
                  'Proyecto subido a la BBDD y a la Blockchain';
                  
                Swal.fire({
                  icon: 'success',
                  text: successMessage
                }).then(() => {
                  this.close.emit(true);
                });
        
                if (!this.isEditMode) {
                  this.clearDraftStorage();
                  this.id = Date.now().toString();
                  this.resetVariables();
                }
              });
            }
          });
          };
          
          checkEvents(15); // Intentar 15 veces (máximo 45 segundos de retraso tolerado en el nodo RPC)
        });
      })
      .catch(() => {
        if (!this.isEditMode) {
          this.afs.collection('investments').doc(id).delete();
          this.id = Date.now().toString();
        }

        Swal.close();
        Swal.fire({
          icon: 'error',
          title: 'Transacción errónea',
          text: 'Algo ha ido mal, la transacción NO se ha realizado'
        });
        this.loadingFlag = false;
        this.formNewNft.enable({ emitEvent: false });
        
        // Rehabilitar formularios de propiedades
        this.viviendasArray.controls.forEach(control => {
          if (control instanceof FormGroup) {
            control.enable({ emitEvent: false });
          }
        });
      });
  }

  formatToWei(num: number) {
    return this.web3.utils.toWei(num.toString(), 'ether');
  }

  resetVariables() {
    // Reset del formulario principal
    this.formNewNft.reset();
    
    // Reset de propiedades - mantener solo una propiedad por defecto
    this.propertiesArray.clear();
    this.propertiesArray.push(this.createPropertyFormGroup());
    this.activeViviendaIndex = 0;
    
    // Reset archivos locales
    this.fotoMain = null;
    this.localMainImageFile = null;
    this.localDocuments = {};
    this.whitePaper = null;
    this.dosier = null;
    this.infoToken = null;
    
    // Reset valores por defecto
    this.stableCoinAddress?.patchValue('0x8f3Cf7ad23Cd3CaDbD9735AFf958023239c6A063');
    this.aggregatorStableCoinDollar?.patchValue('0x4746DeC9e833A82EC7C2C1356372CcF2cfcD2F3D');
  }

  // Método para obtener imágenes de la galería de la vivienda activa
  getActiveViviendaImages(): string[] {
    return this.gallery?.value || [];
  }

  // Método para manejar la selección de imágenes desde componentes hijos
  onImageUpload(event: any) {
    const file = event.event.target.files[0];
    if (file) {
      if (event.id === 'fotoPrincipal') {
        this.localMainImageFile = file;
        // Crear URL local para previsualización
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.fotoMain = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    }
  }

  onImageRemoved(id: string) {
    if (id === 'fotoPrincipal') {
      this.localMainImageFile = null;
      this.fotoMain = null;
      this.formNewNft.get('mainImageUrl')?.setValue(null);
    }
  }

  // Manejar imágenes seleccionadas desde la galería
  handleGalleryImageSelected(event: { file: File; index: number; propertyId: string }): void {
    // Guardar el archivo para subirlo más tarde
    if (!this.localGalleryImages[event.propertyId]) {
      this.localGalleryImages[event.propertyId] = {};
    }
    this.localGalleryImages[event.propertyId][event.index] = event.file;
    
    // Subir inmediatamente a Firebase Storage
    this.uploadGalleryImageToStorage(event.file, event.propertyId, event.index);
  }

  onGalleryImagesReordered(event: { previousIndex: number; currentIndex: number; propertyId: string }): void {
    const imagesForProperty = this.localGalleryImages[event.propertyId];
    if (imagesForProperty) {
      const newImages: { [index: number]: File } = {};
      const keys = Object.keys(imagesForProperty).map(k => parseInt(k, 10));
      
      keys.forEach(key => {
        let newKey = key;
        if (key === event.previousIndex) {
          newKey = event.currentIndex;
        } else if (key > event.previousIndex && key <= event.currentIndex) {
          newKey--;
        } else if (key < event.previousIndex && key >= event.currentIndex) {
          newKey++;
        }
        newImages[newKey] = imagesForProperty[key];
      });
      
      this.localGalleryImages[event.propertyId] = newImages;
    }
  }

  onGalleryImageRemoved(event: { index: number; propertyId: string }): void {
    if (this.localGalleryImages[event.propertyId] && this.localGalleryImages[event.propertyId][event.index]) {
      delete this.localGalleryImages[event.propertyId][event.index];
    }
    
    // Opcional: si quisieras borrar de Storage podrías hacerlo aquí
    const activeProperty = this.propertiesArray.controls.find(
      control => control.get('id')?.value === event.propertyId
    ) as FormGroup;
    
    if (activeProperty) {
      const galleryArray = activeProperty.get('gallery') as FormArray;
      if (galleryArray && galleryArray.controls[event.index]) {
        galleryArray.controls[event.index].setValue('');
      }
    }
  }

  // Subir imagen de galería a Firebase Storage
  private async uploadGalleryImageToStorage(file: File, propertyId: string, index: number): Promise<void> {
    if (!this.id) {
      console.error('No hay ID de proyecto disponible');
      return;
    }

    const fileName = this.sanitizeFileName(file.name);
    const imagePath = `investments/${this.id}/property-${propertyId}/gallery/${Date.now()}_${index}_${fileName}`;

    try {
      const downloadURL = await this.uploadFileToStorageWithRetry(file, imagePath);
      
      // Actualizar el FormArray de la galería con la URL
      const propertyForm = this.propertiesArray.controls.find(
        control => control.get('id')?.value === propertyId
      );
      
      if (propertyForm) {
        const galleryArray = propertyForm.get('gallery') as FormArray;
        
        // Si el índice ya existe, actualizar; si no, agregar nuevo FormControl
        if (galleryArray.controls[index]) {
          (galleryArray.controls[index] as FormControl<string>).setValue(downloadURL);
        } else {
          // Asegurar que hay suficientes controles
          while (galleryArray.length <= index) {
            galleryArray.push(new FormControl<string>(''));
          }
          (galleryArray.controls[index] as FormControl<string>).setValue(downloadURL);
        }
        
        // Actualizar también el preview en el componente hijo si es necesario
        console.log(`✅ Imagen subida y URL guardada: ${downloadURL}`);
      }
    } catch (error) {
      console.error('Error subiendo imagen de galería:', error);
      // Mantener el preview base64 si falla la subida (el usuario puede intentar de nuevo)
    }
  }

  // Método para subir archivos pendientes a Firebase Storage
  private async uploadPendingFiles(): Promise<void> {
    // Temporalmente deshabilitar verificación de permisos para evitar bloqueos
    console.log('📤 Intentando subir archivos...');
    
    // Verificar si el usuario tiene permisos de Firebase Storage
    // const hasStoragePermissions = await this.checkStoragePermissions();
    
    // if (!hasStoragePermissions) {
    //   console.warn('⚠️ Usuario no tiene permisos de Firebase Storage. Continuando sin subir archivos.');
    //   return;
    // }

    const uploadPromises: Promise<string>[] = [];

    // Subir imagen principal si existe
    if (this.localMainImageFile) {
      const mainImagePath = `investments/${this.id}/main-image/${this.sanitizeFileName(this.localMainImageFile.name)}`;
      uploadPromises.push(this.uploadFileToStorageWithRetry(this.localMainImageFile, mainImagePath));
    }

    // Subir documentos si existen
    for (const [docType, file] of Object.entries(this.localDocuments)) {
      const docPath = `investments/${this.id}/documents/${docType}/${this.sanitizeFileName(file.name)}`;
      uploadPromises.push(this.uploadFileToStorageWithRetry(file, docPath));
    }

    // Subir imágenes de galería pendientes (si hay alguna que no se haya subido inmediatamente)
    for (const [propertyId, images] of Object.entries(this.localGalleryImages)) {
      for (const [indexStr, file] of Object.entries(images)) {
        const index = parseInt(indexStr, 10);
        const fileName = this.sanitizeFileName(file.name);
        const imagePath = `investments/${this.id}/property-${propertyId}/gallery/${Date.now()}_${index}_${fileName}`;
        uploadPromises.push(this.uploadFileToStorageWithRetry(file, imagePath).then(url => {
          // Actualizar el FormArray con la URL
          const propertyForm = this.propertiesArray.controls.find(
            control => control.get('id')?.value === propertyId
          );
          if (propertyForm) {
            const galleryArray = propertyForm.get('gallery') as FormArray<FormControl<string>>;
            if (galleryArray.controls[index]) {
              (galleryArray.controls[index] as FormControl<string>).setValue(url);
            }
          }
          return url;
        }));
      }
    }

    // Esperar a que se suban todos los archivos
    if (uploadPromises.length > 0) {
      try {
        const urls = await Promise.all(uploadPromises);
        let urlIndex = 0;

        // Asignar URLs a las propiedades correspondientes
        if (this.localMainImageFile) {
          this.fotoMain = urls[urlIndex++];
        }

        // Asignar URLs de documentos
        for (const docType of Object.keys(this.localDocuments)) {
          const url = urls[urlIndex++];
          const mainProp = this.getMainPropertyForm(true);
          const storedDocs = mainProp?.get('documents')?.value;
          const currentDocs = Array.isArray(storedDocs) ? [...storedDocs] : [];
          const doc = currentDocs.find((d: any) =>
            d.docType === docType ||
            d.slot === docType ||
            d.documentType === docType ||
            d.name === this.localDocuments[docType].name
          );
          if (doc) {
            doc.url = url;
            doc.docType = docType;
            doc.slot = docType;
            delete doc.file;
          }
          
          if (docType === 'urlWhitepapperPdf') {
            this.whitePaper = url;
            this.formNewNft.get('urlWhitepapperPdf')?.setValue(url);
          } else if (docType === 'urlDosierPdf') {
            this.dosier = url;
            this.formNewNft.get('urlDosierPdf')?.setValue(url);
          } else if (docType === 'tokenInfoPdfUrl') {
            this.infoToken = url;
            this.formNewNft.get('tokenInfoPdfUrl')?.setValue(url);
            this.formNewNft.get('urlInfoTokenPdf')?.setValue(url);
          } else if (docType === 'propertyRegistry') {
            if (mainProp) mainProp.get('propertyRegistry')?.setValue(url);
          } else if (docType === 'loanSubscriptionAgreement') {
            if (mainProp) mainProp.get('loanSubscriptionAgreement')?.setValue(url);
          } else if (docType === 'agentMandateContract') {
            if (mainProp) mainProp.get('agentMandateContract')?.setValue(url);
          }
          
          if (mainProp) mainProp.get('documents')?.setValue(currentDocs, {emitEvent: false});
        }
      } catch (error) {
        console.error('Error subiendo archivos:', error);
        // Si falla la subida, continuar sin archivos
        console.warn('Continuando sin subir archivos debido a error de permisos');
      }
    }
  }

  // Método para verificar permisos de Firebase Storage
  private async checkStoragePermissions(): Promise<boolean> {
    try {
      // Verificar si el usuario está autenticado
      const user = this.authService.userAuth.getValue();
      if (!user) {
        console.warn('ÔÜá´©Å Usuario no autenticado');
        return false;
      }

      console.log('­ƒöì Verificando permisos de Storage para usuario:', user.uid);

      // Intentar crear una referencia simple para verificar permisos
      const testRef = this.storage.ref('test-permissions-check');
      await testRef.getDownloadURL().toPromise();
      console.log('Ô£à Permisos de Storage verificados correctamente');
      return true;
    } catch (error: any) {
      console.log('­ƒöì Verificación de permisos de Storage:', error);
      
      if (error?.code === 'storage/unauthorized') {
        console.warn('ÔÜá´©Å Usuario no tiene permisos de Firebase Storage (unauthorized)');
        console.warn('­ƒÆí Solución: Verificar las reglas de Firebase Storage en la consola');
        return false;
      }
      
      if (error?.code === 'storage/object-not-found') {
        // Si el objeto no existe pero no hay error de permisos, asumir que tiene permisos
        console.log('Ô£à Permisos de Storage OK (objeto no encontrado es normal)');
        return true;
      }
      
      // Para otros errores, asumir que tiene permisos
      console.log('Ô£à Asumiendo permisos de Storage OK');
      return true;
    }
  }

  // Método auxiliar para subir un archivo a Firebase Storage con reintentos
  private async uploadFileToStorageWithRetry(file: File, path: string, maxRetries: number = 3): Promise<string> {
    // Limpiar el nombre del archivo para evitar caracteres problemáticos
    const cleanFileName = this.sanitizeFileName(file.name);
    const cleanPath = path.replace(file.name, cleanFileName);
    
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
      try {
        console.log(`­ƒöä Intento ${attempt} de subida: ${cleanPath}`);
        return await this.uploadFileToStorage(file, cleanPath);
      } catch (error: any) {
        console.error(`ÔØî Intento ${attempt} fallido al subir archivo:`, error);
        
        if (error?.code === 403 || error?.message?.includes('Permission denied')) {
          console.warn('­ƒöÆ Error de permisos en Firebase Storage. Verificando autenticación...');
          
          // Verificar si el usuario está autenticado
          const user = this.authService.userAuth.getValue();
          if (!user) {
            console.error('ÔØî Usuario no autenticado. No se puede subir archivo.');
            throw new Error('Usuario no autenticado');
          }
          
          console.log('Ô£à Usuario autenticado:', user.uid);
          
          // Intentar con nombre único y ruta más simple
          const uniqueFileName = `${Date.now()}_${cleanFileName}`;
          const simplePath = `investments/${this.id}/${uniqueFileName}`;
          
          try {
            console.log(`­ƒöä Intentando con ruta simplificada: ${simplePath}`);
            return await this.uploadFileToStorage(file, simplePath);
          } catch (retryError) {
            console.error('ÔØî Error con ruta simplificada:', retryError);
            if (attempt === maxRetries) {
              console.error('ÔØî Error persistente al subir archivo después de reintentos:', retryError);
              throw retryError;
            }
          }
        } else if (attempt === maxRetries) {
          throw error;
        }
        
        // Esperar antes del siguiente intento
        await new Promise(resolve => setTimeout(resolve, 1000 * attempt));
      }
    }
    throw new Error('Error al subir archivo después de múltiples intentos');
  }

  // Método para limpiar nombres de archivos
  private sanitizeFileName(fileName: string): string {
    return fileName
      .replace(/[^a-zA-Z0-9.-]/g, '_') // Reemplazar caracteres especiales
      .replace(/\s+/g, '_') // Reemplazar espacios
      .toLowerCase();
  }

  // Método para limpiar campos undefined de un objeto
  /**
   * Convierte un valor de fecha (Firestore Timestamp, Date, string ISO o "yyyy-MM-dd")
   * al formato local "yyyy-MM-ddTHH:mm" que requiere un input type="datetime-local".
   * Devuelve null si el valor está vacío o no es una fecha válida.
   */
  private toDatetimeLocalString(value: any): string | null {
    if (!value) {
      return null;
    }
    // Fecha sin hora ("yyyy-MM-dd") proveniente del antiguo input type="date":
    // se asume medianoche local para no desplazarla por la zona horaria.
    if (typeof value === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return `${value}T00:00`;
    }
    let date: Date;
    if (typeof value?.toDate === 'function') {
      date = value.toDate();
    } else if (value instanceof Date) {
      date = value;
    } else if (typeof value?.seconds === 'number') {
      date = new Date(value.seconds * 1000);
    } else {
      date = new Date(value);
    }
    if (isNaN(date.getTime())) {
      return null;
    }
    const tzoffset = date.getTimezoneOffset() * 60000;
    return new Date(date.getTime() - tzoffset).toISOString().slice(0, 16);
  }

  private cleanUndefinedFields(obj: any): any {
    if (obj === null || obj === undefined) {
      return null;
    }

    // Preservar fechas tal cual: un Date no tiene propiedades enumerables, así que
    // iterarlo lo convertiría en {} y se perdería (p. ej. activationDate).
    if (obj instanceof Date) {
      return obj;
    }

    if (Array.isArray(obj)) {
      return obj.map(item => this.cleanUndefinedFields(item));
    }

    if (typeof obj === 'object') {
      const cleaned: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          if (value !== undefined) {
            cleaned[key] = this.cleanUndefinedFields(value);
          }
        }
      }
      return cleaned;
    }
    
    return obj;
  }

  private makeFirestoreCompatible(obj: any): any {
    if (obj === null || obj === undefined) {
      return null;
    }
    
    if (Array.isArray(obj)) {
      // Para arrays, procesar cada elemento recursivamente
      // Firestore puede manejar arrays de objetos, así que no convertir a JSON
      return obj.map(item => {
        // Procesar recursivamente cada item, manteniendo su estructura
        return this.makeFirestoreCompatible(item);
      });
    }
    
    if (typeof obj === 'object') {
      const compatible: any = {};
      for (const key in obj) {
        if (obj.hasOwnProperty(key)) {
          const value = obj[key];
          
          // IMPORTANTE: Mantener el array 'properties' como array de objetos (Firestore lo soporta)
          if (key === 'properties' && Array.isArray(value)) {
            compatible[key] = value.map(property => {
              // Procesar cada propiedad recursivamente, pero mantenerla como objeto
              return this.makeFirestoreCompatible(property);
            });
            continue;
          }
          
          // Si es un FormControl o similar, obtener su valor
          if (value && typeof value === 'object' && 'value' in value && !Array.isArray(value) && !(value instanceof Date)) {
            compatible[key] = this.makeFirestoreCompatible(value.value);
            continue;
          }
          
          // Convertir objetos Date a timestamps
          if (value instanceof Date) {
            compatible[key] = value;
          }
          // Mantener objetos simples como objetos (Firestore los soporta directamente)
          // NO convertir a JSON - Firestore puede manejar objetos anidados simples como 'location'
          else if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            // Procesar recursivamente pero mantener como objeto
            compatible[key] = this.makeFirestoreCompatible(value);
          }
          // Mantener arrays simples - normalizar especialmente el array gallery dentro de properties
          else if (Array.isArray(value)) {
            // Si es el array gallery dentro de una property, normalizarlo especialmente
            if (key === 'gallery') {
              compatible[key] = this.normalizeGalleryArray(value);
            } else {
              compatible[key] = this.makeFirestoreCompatible(value);
            }
          }
          // Mantener valores primitivos
          else {
            compatible[key] = value;
          }
        }
      }
      return compatible;
    }
    
    return obj;
  }

  /**
   * Normaliza los atributos eliminando acentos, ñ y corrigiendo valores
   * @param attributesString String JSON con los atributos
   * @returns String JSON normalizado
   */
  private normalizeAttributes(attributesString: string): string {
    if (!attributesString || attributesString.trim() === '' || attributesString === '{}') {
      return '{}';
    }

    try {
      // Función para eliminar acentos y ñ
      const removeAccents = (str: string): string => {
        return str
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '') // Elimina diacríticos
          .replace(/ñ/g, 'n')
          .replace(/Ñ/g, 'N');
      };

      // Función para normalizar valores
      const normalizeValue = (value: any): any => {
        if (typeof value === 'string') {
          // Normalizar valores comunes
          const normalized = value.trim();
          if (normalized === 'Sí' || normalized === 'Sí' || normalized === 'Si' || normalized === 'si' || normalized === 'SI') {
            return 'Si';
          }
          if (normalized === 'No' || normalized === 'no' || normalized === 'NO') {
            return 'No';
          }
          // Si es numérico, convertir
          if (!isNaN(Number(normalized)) && normalized !== '') {
            return Number(normalized);
          }
          return removeAccents(normalized);
        }
        return value;
      };

      // Parsear el string JSON
      let attributes: any = {};
      try {
        const sanitizedString = attributesString.startsWith('{') && attributesString.endsWith('}')
          ? attributesString
          : `{${attributesString}}`;
        attributes = JSON.parse(sanitizedString);
      } catch {
        // Si no es JSON válido, intentar parsearlo como objeto
        try {
          attributes = this.getAtributosJsonFromString(attributesString);
        } catch {
          return '{}';
        }
      }

      // Normalizar claves y valores
      const normalizedAttributes: Record<string, any> = {};
      for (const [key, value] of Object.entries(attributes)) {
        const normalizedKey = removeAccents(key);
        normalizedAttributes[normalizedKey] = normalizeValue(value);
      }

      // Convertir de nuevo a string JSON
      return JSON.stringify(normalizedAttributes);
    } catch (error) {
      console.error('Error normalizando atributos:', error);
      return '{}';
    }
  }

  private getLegacyAttributesFromProperties(properties: any[]): any {
    if (!properties || properties.length === 0) {
      return {};
    }

    // Tomar los atributos de la primera propiedad para mantener compatibilidad
    const firstProperty = properties[0];
    const attributes: any = {};

    // Mapear campos de la propiedad a atributos del formato antiguo
    if (firstProperty.floor !== null && firstProperty.floor !== undefined) {
      attributes['Planta'] = firstProperty.floor;
    }
    if (firstProperty.rooms !== null && firstProperty.rooms !== undefined) {
      attributes['Habitaciones'] = firstProperty.rooms;
    }
    if (firstProperty.bathrooms !== null && firstProperty.bathrooms !== undefined) {
      attributes['Baños'] = firstProperty.bathrooms;
    }
    if (firstProperty.squareMeters !== null && firstProperty.squareMeters !== undefined) {
      attributes['Metros cuadrados'] = firstProperty.squareMeters;
    }
    if (firstProperty.exterior !== null && firstProperty.exterior !== undefined) {
      attributes['Exterior'] = firstProperty.exterior ? 'Sí' : 'No';
    }
    if (firstProperty.elevator !== null && firstProperty.elevator !== undefined) {
      attributes['Ascensor'] = firstProperty.elevator ? 'Sí' : 'No';
    }
    if (firstProperty.penthouse !== null && firstProperty.penthouse !== undefined) {
      attributes['Ático'] = firstProperty.penthouse ? 'Sí' : 'No';
    }
    if (firstProperty.duplex !== null && firstProperty.duplex !== undefined) {
      attributes['Dúplex'] = firstProperty.duplex ? 'Sí' : 'No';
    }
    if (firstProperty.building !== null && firstProperty.building !== undefined) {
      attributes['Edificio'] = firstProperty.building ? 'Sí' : 'No';
    }
    if (firstProperty.pool !== null && firstProperty.pool !== undefined) {
      attributes['Piscina'] = firstProperty.pool ? 'Sí' : 'No';
    }
    if (firstProperty.nobleFacade !== null && firstProperty.nobleFacade !== undefined) {
      attributes['Fachada noble'] = firstProperty.nobleFacade ? 'Sí' : 'No';
    }

    return attributes;
  }

  // Método auxiliar para subir un archivo a Firebase Storage
  private async uploadFileToStorage(file: File, path: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileRef = this.storage.ref(path);
      const task = this.storage.upload(path, file);

      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe({
            next: (url: string) => resolve(url),
            error: (error: any) => {
              console.error('Error obteniendo URL de descarga:', error);
              reject(error);
            }
          });
        })
      ).subscribe({
        error: (error) => {
          console.error('Error durante la subida:', error);
          reject(error);
        }
      });
    });
  }

  // Método para eliminar proyecto
  deleteProyect() {
    if (this.isProjectInBlockchain()) {
      Swal.fire({
        icon: 'warning',
        title: 'No se puede eliminar',
        text: 'No se pueden eliminar proyectos que están desplegados en blockchain por seguridad.',
      });
      return;
    }

    Swal.fire({
      title: '¿Estás seguro?',
      text: 'Esta acción no se puede deshacer',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.afs.collection('investments').doc(this.id).delete()
          .then(() => {
            Swal.fire(
              'Eliminado',
              'El proyecto ha sido eliminado.',
              'success'
            ).then(() => {
              this.close.emit(true);
            });
          })
          .catch((error) => {
            Swal.fire(
              'Error',
              'No se pudo eliminar el proyecto.',
              'error'
            );
          });
      }
    });
  }

  

  uploadImg(e: any, id: string) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    // Redimensionar imagen antes de subir
    this.resizeImage(file, 1920, 1080).then((resizedFile: Blob) => {
      const filePath = `investments/${this.id}/property-${this.activeViviendaIndex + 1}/${file.name}`;
      const fileRef = this.storage.ref(filePath);
      const task = this.storage.upload(filePath, resizedFile);

      task.snapshotChanges().pipe(
        finalize(() => {
          fileRef.getDownloadURL().subscribe((res: string) => {
            if (id === 'fotoPrincipal') {
              this.fotoMain = res;
              this.mainImageUrl?.setValue(res);
            } else {
              // Añadir a la galería de la propiedad activa
              const currentGallery = this.gallery?.value || [];
              currentGallery.push(res);
              this.gallery?.setValue(currentGallery);
            }
            this.loadingFlag = false;
          })
        })).subscribe();
    }).catch((error) => {
      console.error('Error redimensionando imagen:', error);
      this.loadingFlag = false;
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Error procesando la imagen. Inténtalo de nuevo.'
      });
    });
  }

  uploadWhitepaper(e: any) {
    this.uploadDocument(e, 'urlWhitepapperPdf');
  }

  uploadDosier(e: any) {
    this.uploadDocument(e, 'urlDosierPdf');
  }

  uploadInfoToken(e: any) {
    this.uploadDocument(e, 'tokenInfoPdfUrl');
  }

  // NUEVO MÉTODO: Upload para documentos adicionales
  uploadDocument(e: any, documentType: string) {
    this.loadingFlag = true;
    const file = e.target.files[0];

    const filePath = `investments/${this.id}/documents/${documentType}/${file.name}`;
    const fileRef = this.storage.ref(filePath);
    const task = this.storage.upload(filePath, file);

    task.snapshotChanges().pipe(
      finalize(() => {
        fileRef.getDownloadURL().subscribe((res: string) => {
          // Actualizar el FormControl correspondiente y las variables locales
          if (documentType === 'urlWhitepapperPdf') {
            this.whitePaper = res;
            this.formNewNft.get(documentType)?.setValue(res);
          } else if (documentType === 'urlDosierPdf') {
            this.dosier = res;
            this.formNewNft.get(documentType)?.setValue(res);
          } else if (documentType === 'tokenInfoPdfUrl') {
            this.infoToken = res;
            this.formNewNft.get(documentType)?.setValue(res);
          } else {
            // Para documentos de propiedad específica
            this.activeProperty?.get(documentType)?.setValue(res);
          }
          this.loadingFlag = false;
        })
      }))
        .pipe()
        .subscribe();
  }

  urlValidator(control: AbstractControl): { [key: string]: any } | null {
    const validUrlRegex = /^(ftp|http|https):\/\/(?:(?:[a-z0-9][a-z0-9-]*[a-z0-9]\.)+[a-z]{2,}|((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?))(?::[0-9]{1,5})?(?:\/[^\s]*)?$/i;
    const value = control.value;
    const isValid = validUrlRegex.test(value);
    return isValid ? null : { 'invalidUrl': { value } };
  }

  async createProjectWallet(projectId: string) {
    try {
      this.loaderService.showSpinner('Creando wallet para el proyecto');
      const response = await this.projectsV1Service.createProjectWallet(projectId);
    } catch (err) {
      console.error('Error creando wallet del proyecto:', err);
      Swal.fire({
        icon: 'error',
        title: 'Error creando wallet',
        text: 'Ha ocurrido un error creando la wallet del proyecto. Verifica la consola para más detalles.'
      });
      // No eliminar el proyecto si falla la wallet, solo mostrar error
      // await this.afs.collection('investments').doc(projectId).delete();
    } finally {
      this.loaderService.hideSpinner();
    }
  }

  setActiveTab(tabId: any): void {
    this.activeTab = tabId;
  }

  // Métodos para manejar propiedades
  setActiveProperty(index: any): void {
    if (index >= 0 && index < this.propertiesArray.length) {
      // Guardar las secciones financieras y eventos de calendario actuales del servicio en la propiedad anterior
      const previousIndex = this.activeViviendaIndex;
      if (previousIndex >= 0 && previousIndex < this.propertiesArray.length && previousIndex !== index) {
        const previousProperty = this.propertiesArray.at(previousIndex) as FormGroup;
        if (previousProperty) {
          const currentSections = this.serializeFinancialSections();
          previousProperty.get('financialSections')?.setValue(currentSections);
          
          const currentCalendarEvents = this.serializeCalendarEvents();
          previousProperty.get('calendarEvents')?.setValue(currentCalendarEvents);
          
          // Guardar documentos actuales (los documentos se guardan directamente en el FormControl, no necesitan serialización)
          const currentDocuments = this.activeProperty?.get('documents')?.value || [];
          previousProperty.get('documents')?.setValue(currentDocuments);
        }
      }
      
      // Cambiar a la nueva propiedad
      this.activeViviendaIndex = index;
      
      // Sincronizar metricas financieras (Hero) de la nueva propiedad seleccionada
      const syncRootHeroWithActiveProperty = () => {
        const activeProp = this.activeProperty;
        if (activeProp) {
           const irrValue = activeProp.get('actualIRR')?.value;
           const rootIrrControl = this.formNewNft.get('annualProfitability');
           if (irrValue !== undefined && irrValue !== null && rootIrrControl && rootIrrControl.value !== irrValue) {
              rootIrrControl.setValue(irrValue, { emitEvent: false });
           }
  
           const durValue = activeProp.get('actualDuration')?.value;
           const rootDurControl = this.formNewNft.get('estimatedDeliveryPeriod');
           if (durValue !== undefined && durValue !== null && rootDurControl && rootDurControl.value !== durValue) {
              rootDurControl.setValue(durValue, { emitEvent: false });
           }
        }
      };
      syncRootHeroWithActiveProperty();

      // Cargar las secciones financieras de la nueva propiedad en el servicio
      const newProperty = this.propertiesArray.at(index) as FormGroup;
      if (newProperty) {
        const savedSections = newProperty.get('financialSections')?.value;
        if (savedSections) {
          if (Array.isArray(savedSections) && savedSections.length > 0) {
            this.loadFinancialSectionsFromProperty(savedSections);
          } else if (typeof savedSections === 'string' && savedSections.trim() !== '') {
            this.loadFinancialSectionsFromProperty(savedSections);
          }
        } else {
          // Si no hay secciones guardadas, usar las por defecto
          this.financialSectionService.resetToDefaultSections();
        }
        
        // Cargar los eventos de calendario de la nueva propiedad
        const savedCalendarEvents = newProperty.get('calendarEvents')?.value;
        if (savedCalendarEvents && Array.isArray(savedCalendarEvents) && savedCalendarEvents.length > 0) {
          this.loadCalendarEventsFromProperty(savedCalendarEvents);
        }
        
        // Los documentos se cargan automáticamente por el componente cuando cambia propertyForm
      }
      
      // Forzar detección de cambios para actualizar los componentes hijos
      this.forceFormUpdate();
    }
  }

  private forceFormUpdate(): void {
    // Forzar la actualización del formulario activo
    const activeProp = this.activeProperty;
    if (activeProp) {
      // Disparar eventos de cambio para que los componentes hijos se actualicen
      activeProp.updateValueAndValidity({ emitEvent: true });
    }
  }

  addProperty(): void {
      // Guardar las secciones financieras y eventos de calendario actuales en la propiedad activa antes de agregar una nueva
      const activePropertyForm = this.activeProperty;
      if (activePropertyForm) {
        const currentSections = this.serializeFinancialSections();
        activePropertyForm.get('financialSections')?.setValue(currentSections);
        
        const currentCalendarEvents = this.serializeCalendarEvents();
        activePropertyForm.get('calendarEvents')?.setValue(currentCalendarEvents);
        
        // Guardar documentos actuales
        const currentDocuments = activePropertyForm.get('documents')?.value || [];
        activePropertyForm.get('documents')?.setValue(currentDocuments);
      }
    
    // Crear nueva propiedad con secciones financieras por defecto
    const newProperty = this.createPropertyFormGroup();
    newProperty.patchValue({
      name: `Property ${this.propertiesArray.length + 1}`
    });

    // Copiar eventos del calendario de la primera propiedad (Propiedad 1) si existe
    if (this.propertiesArray.length > 0) {
      const firstProperty = this.propertiesArray.at(0);
      const firstPropertyEvents = firstProperty.get('calendarEvents')?.value;
      if (firstPropertyEvents && Array.isArray(firstPropertyEvents)) {
        // Clonación profunda de los eventos para evitar referencias cruzadas
        const copiedEvents = JSON.parse(JSON.stringify(firstPropertyEvents));
        newProperty.get('calendarEvents')?.setValue(copiedEvents);
      }
    }

    this.propertiesArray.push(newProperty);
    this.activeViviendaIndex = this.propertiesArray.length - 1;
    
    // Inicializar secciones financieras por defecto para la nueva propiedad
    this.financialSectionService.resetToDefaultSections();
  }

  removeProperty(index: any): void {
    if (this.propertiesArray.length > 1) {
      this.propertiesArray.removeAt(index);
      
      // Ajustar índice de la portada si es necesario
      if (this.mainPropertyIndex === index) {
        this.mainPropertyIndex = -1;
        this.mainPropertyCoverIndex = 0;
      } else if (this.mainPropertyIndex > index) {
        this.mainPropertyIndex--;
      }

      // Ajustar el índice activo si es necesario
      if (this.activeViviendaIndex >= this.propertiesArray.length) {
        this.activeViviendaIndex = Math.max(0, this.propertiesArray.length - 1);
      }
      
      // Renumerar las propiedades
      this.renumberProperties();
    }
  }

  setMainProperty(index: number): void {
    if (this.mainPropertyIndex === index) {
      this.mainPropertyIndex = -1;
      this.mainPropertyCoverIndex = 0;
      console.log('🌟 Propiedad principal (Cover) quitada');
    } else {
      this.mainPropertyIndex = index;
      this.mainPropertyCoverIndex = 0;
      console.log('🌟 Propiedad principal (Cover) cambiada a:', index);
    }
  }

  setMainPropertyCoverIndex(index: number): void {
    this.mainPropertyCoverIndex = index;
    console.log('🌟 Índice de foto portada cambiado a: ', index);
  }

  getResolvedCoverImage(): string {
    let coverImage = this.fotoMain || this.formNewNft.get('mainImage')?.value;
    
    if (this.mainPropertyIndex >= 0 && this.propertiesArray.length > this.mainPropertyIndex) {
      const selectedProperty = this.propertiesArray.at(this.mainPropertyIndex) as FormGroup;
      const gallery = selectedProperty.get('gallery')?.value || [];
      
      if (gallery.length > this.mainPropertyCoverIndex && gallery[this.mainPropertyCoverIndex]) {
        // Usa la foto en el índice seleccionado de la galería
        coverImage = gallery[this.mainPropertyCoverIndex];
      } else if (gallery.length > 0 && gallery[0]) {
        // Fallback a la primera foto si existe
        coverImage = gallery[0];
      }
    }
    return coverImage;
  }

  private renumberProperties(): void {
    this.propertiesArray.controls.forEach((property, index) => {
      property.patchValue({
        name: `Property ${index + 1}`
      });
    });
  }

  getPropertyName(index: number): string {
    const property = this.propertiesArray.at(index);
    return property?.get('name')?.value || `Property ${index + 1}`;
  }

  canRemoveProperty(): boolean {
    return this.propertiesArray.length > 1;
  }

  // Métodos para manejar viviendas (compatibilidad)
  setActiveVivienda(index: number): void {
    this.setActiveProperty(index);
  }

  addVivienda(): void {
    this.addProperty();
  }

  removeVivienda(index: number): void {
    this.removeProperty(index);
  }

  private renumberViviendas(): void {
    this.renumberProperties();
  }

  getViviendaName(index: number): string {
    const vivienda = this.viviendasArray.at(index);
    return vivienda?.get('nombre')?.value || `Vivienda ${index + 1}`;
  }

  canRemoveVivienda(): boolean {
    return this.canRemoveProperty();
  }

  // Métodos para el header
  connect() {
    console.log('Conectando wallet desde componente principal...');
    this.connSrv.connect();
  }

  private initializeBlockchainState() {
    this.authService.userAuth.subscribe(async (res: any) => {
      if (res === null) return;
      
      this.afs
        .collection('users')
        .doc(res.uid)
        .valueChanges()
        .subscribe((userData: any) => {
          this.hideBlockchain = userData?.hideBlockchain ?? true;
        });
    });
  }

  private truncateEthAddress(address: string): string {
    if (!address) return '';
    return `${address.slice(0, 6)}...${address.slice(-4)}`;
  }

  private getInvalidFields(formGroup: FormGroup, prefix: string = ''): string[] {
    const invalidFields: string[] = [];
    
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control && control.invalid && (control.dirty || control.touched)) {
        const fieldName = this.getFieldDisplayName(key);
        invalidFields.push(`${prefix}${fieldName}`);
      }
      
      // Si es un FormArray, verificar cada elemento
      if (control instanceof FormArray) {
        control.controls.forEach((arrayControl, index) => {
          if (arrayControl instanceof FormGroup) {
            const fieldName = this.getFieldDisplayName(key);
            const arrayInvalidFields = this.getInvalidFields(arrayControl, `${prefix}${fieldName} ${index + 1}: `);
            invalidFields.push(...arrayInvalidFields);
          }
        });
      }
    });
    
    return invalidFields;
  }

  private getFieldDisplayName(fieldKey: string): string {
    const fieldNames: { [key: string]: string } = {
      'title': 'Título del proyecto',
      'developer': 'Promotora',
      'country': 'País',
      'stateRegion': 'Estado/CCAA/Provincia',
      'city': 'Ciudad',
      'neighborhood': 'Barrio',
      'postalCode': 'Código postal',
      'street': 'Calle',
      'streetNumber': 'Número',
      'googleMapsIframe': 'Ubicación en Google Maps',
      'description': 'Descripción',
      'activationDate': 'Fecha de activación',
      'estimatedDeliveryPeriod': 'Período de entrega estimado',
      'annualProfitability': 'Rentabilidad anual',
      'amountToSell': 'Cantidad a vender',
      'tokenPrice': 'Precio del token',
      'minimumInvestment': 'Inversión mínima',
      'stableCoinAddress': 'Dirección de stablecoin',
      'beneficiaryAddress': 'Dirección del beneficiario',
      'aggregatorStableCoinDollar': 'Agregador de stablecoin',
      'tokenName': 'Nombre del token',
      'tokenSymbol': 'Símbolo del token',
      'floor': 'Planta',
      'rooms': 'Habitaciones',
      'bathrooms': 'Baños',
      'squareMeters': 'Metros cuadrados',
      'launchDate': 'Fecha de lanzamiento',
      'purchaseDate': 'Fecha de compra',
      'renovationStartDate': 'Fecha de inicio de reforma',
      'estimatedDuration': 'Duración estimada',
      'status': 'Estado del proyecto'
    };
    
    return fieldNames[fieldKey] || fieldKey;
  }

  private getInvalidProperties(): string[] {
    const invalidProperties: string[] = [];
    
    this.viviendasArray.controls.forEach((propertyControl, index) => {
      if (propertyControl instanceof FormGroup && propertyControl.invalid) {
        const propertyName = propertyControl.get('name')?.value || `Property ${index + 1}`;
        const invalidFields = this.getInvalidFields(propertyControl);
        if (invalidFields.length > 0) {
          invalidProperties.push(`${propertyName}: ${invalidFields.join(', ')}`);
        }
      }
    });
    
    return invalidProperties;
  }

  // Método de debug para identificar problemas de validación
  debugFormValidation(): void {
    console.log('­ƒöì DEBUG: Formulario principal válido:', this.formNewNft.valid);
    console.log('­ƒöì DEBUG: Errores del formulario principal:', this.formNewNft.errors);
    
    // Solo mostrar información de las propiedades si hay errores específicos
    this.viviendasArray.controls.forEach((propertyControl, index) => {
      if (propertyControl instanceof FormGroup) {
        const propertyName = propertyControl.get('name')?.value || `Property ${index + 1}`;
        console.log(`­ƒöì DEBUG: ${propertyName} válido:`, propertyControl.valid);
        // Solo mostrar errores si los hay (ya que las propiedades no son obligatorias)
        if (propertyControl.invalid && propertyControl.dirty) {
          console.log(`­ƒöì DEBUG: Errores de ${propertyName}:`, propertyControl.errors);
        }
      }
    });
  }

  /**
   * Crea o actualiza el documento investments-reader con los datos necesarios para la card
   * Este método se ejecuta automáticamente al guardar/actualizar un proyecto
   * 
   * NOTA: Este método requiere que las reglas de Firestore permitan escribir en 'investments-reader'
   * para usuarios administradores. Si falla por permisos, el proyecto principal se guarda correctamente
   * pero el documento reader no se crea. Se debe actualizar las reglas de Firestore siguiendo el mismo
   * patrón que 'investments':
   * 
   * match /investments-reader {
   *   allow read: if true;
   *   
   *   match /{id} { 
   *     allow create, update: if checkAdminRol();
   *     allow delete: if false;  // O si quieres permitir eliminación: allow delete: if checkAdminRol();
   *     allow read: if true;
   *   }
   * }
   * 
   * @param investmentData - Datos completos del investment guardado
   */
  private async createOrUpdateInvestmentReader(investmentData: any): Promise<void> {
    try {
      if (!investmentData || !this.id) {
        console.warn('⚠️ No se puede crear investments-reader: datos o ID faltantes');
        return;
      }

      // Verificar que el usuario es administrador antes de intentar escribir
      const isAdmin = this.authService.admin.getValue();
      if (!isAdmin) {
        console.warn('⚠️ Usuario no es administrador, omitiendo creación de investments-reader');
        return;
      }

      // Extraer SOLO los datos necesarios para la card (según newProyect.md líneas 47-57)
      // Solo guardar: título, estado, financiación, objetivo, n inversores, plazo estimado, rentabilidad anual, precio ticket
      const readerData: any = {
        // Referencia al investment real (necesario para cargar el detalle completo)
        investmentId: this.id,
        
        // Título (nameTokens tiene prioridad sobre location según la card)
        nameTokens: investmentData.nameTokens || null,
        location: investmentData.location || null,
        
        // Estado
        proyectStatus: investmentData.proyectStatus || 'En estudio',

        // Fecha de activación (necesaria para el countdown "En estudio" en la card)
        activationDate: investmentData.activationDate || null,

        // Financiación (se calcula en la card: (reserves + amountSold) * (priceToken / 100))
        amountSold: investmentData.amountSold || 0,
        reserves: investmentData.reserves || 0,
        
        // Objetivo (se calcula en la card: amountToSell * priceToken / 100)
        amountToSell: investmentData.amountToSell || 0,
        priceToken: investmentData.priceToken || 0,
        
        // Número de inversores
        numberInvestors: investmentData.numberInvestors || 0,
        
        // Plazo estimado (compatibilidad con ambos campos)
        estimatedDeliveryTime: investmentData.estimatedDeliveryTime || investmentData.estimatedDeliveryPeriod || null,
        
        // Rentabilidad anual (compatibilidad con ambos campos)
        annualReturn: investmentData.annualReturn || investmentData.annualProfitability || 0,
        
        // Precio ticket (ya incluido en priceToken, pero se muestra como priceToken / 100)
        // priceToken ya está arriba
        
        // Imagen principal (necesaria para mostrar en la card)
        mainImage: investmentData.mainImage || investmentData.mainImageUrl || null,
        
        // Campos adicionales necesarios para la lógica de la card (estado, venta privada, etc.)
        blockchain: investmentData.blockchain || false,
        onlyInversors: investmentData.onlyInversors || false,
        managingInvestments: investmentData.managingInvestments || false,
        percentageToPrivateSale: investmentData.percentageToPrivateSale || 0,
        endOfSale: investmentData.endOfSale || 0,
        
        // Para navegación (saber si tiene múltiples properties y mostrar vista intermedia)
        hasMultipleProperties: Array.isArray(investmentData.properties) && investmentData.properties.length > 1,
        
        // Visibilidad (para filtrar proyectos ocultos)
        hide: investmentData.hide !== undefined ? investmentData.hide : false
      };

      // Guardar en la colección investments-reader
      await this.afs.collection('investments-reader').doc(this.id).set(readerData, { merge: true });
      
      console.log('✅ Documento investments-reader creado/actualizado para:', this.id);
    } catch (error: any) {
      // Manejar errores de permisos de manera silenciosa
      if (error?.code === 'permission-denied' || error?.message?.includes('permission') || error?.message?.includes('permissions')) {
        console.warn('⚠️ Permisos insuficientes para crear investments-reader. El proyecto se guardó correctamente, pero el documento reader no se creó.');
        console.warn('⚠️ Por favor, actualiza las reglas de Firestore para permitir que los administradores escriban en investments-reader.');
        console.warn('⚠️ Ver comentario en el método createOrUpdateInvestmentReader() para las reglas necesarias.');
      } else {
        console.error('❌ Error creando/actualizando investments-reader:', error);
      }
      // No fallar el guardado del proyecto principal si falla el reader
    }
  }

  /**
   * Redimensiona una imagen usando Canvas manteniendo la proporción
   * @param file - Archivo de imagen original
   * @param maxWidth - Ancho máximo permitido
   * @param maxHeight - Alto máximo permitido
   * @param quality - Calidad de compresión (0.1 - 1.0)
   * @returns Promise<Blob> - Imagen redimensionada como Blob
   */
  private resizeImage(file: File, maxWidth: number = 1920, maxHeight: number = 1080, quality: number = 0.8): Promise<Blob> {
    return new Promise((resolve, reject) => {
      // Verificar que es una imagen
      if (!file.type.startsWith('image/')) {
        reject(new Error('El archivo no es una imagen válida'));
        return;
      }

      const img = new Image();
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');

      if (!ctx) {
        reject(new Error('No se pudo obtener el contexto del canvas'));
        return;
      }

      img.onload = () => {
        try {
          // Calcular nuevas dimensiones manteniendo la proporción
          let { width, height } = img;
          
          // Si la imagen es más pequeña que los límites, no redimensionar
          if (width <= maxWidth && height <= maxHeight) {
            // Solo comprimir si es necesario
            canvas.width = width;
            canvas.height = height;
            ctx.drawImage(img, 0, 0, width, height);
            canvas.toBlob((blob) => {
              if (blob) {
                resolve(blob);
              } else {
                reject(new Error('Error al convertir la imagen'));
              }
            }, file.type, quality);
            return;
          }

          // Calcular el ratio de redimensionamiento
          const ratio = Math.min(maxWidth / width, maxHeight / height);
          
          // Aplicar el ratio
          width = Math.floor(width * ratio);
          height = Math.floor(height * ratio);

          // Configurar canvas
          canvas.width = width;
          canvas.height = height;

          // Configurar calidad de renderizado
          ctx.imageSmoothingEnabled = true;
          ctx.imageSmoothingQuality = 'high';

          // Dibujar imagen redimensionada
          ctx.drawImage(img, 0, 0, width, height);

          // Convertir a Blob con compresión
          canvas.toBlob((blob) => {
            if (blob) {
              console.log(`Ô£à Imagen redimensionada: ${file.name} (${file.size} bytes ÔåÆ ${blob.size} bytes)`);
              resolve(blob);
            } else {
              reject(new Error('Error al convertir la imagen redimensionada'));
            }
          }, file.type, quality);

        } catch (error) {
          reject(error);
        }
      };

      img.onerror = () => {
        reject(new Error('Error al cargar la imagen'));
      };

      // Cargar la imagen
      img.src = URL.createObjectURL(file);
    });
  }

}
